/*!
 * @license MIT
 * youboralib 6.0.0-rc
 * Copyright NicePopleAtWork <http://nicepeopleatwork.com/>
 * @author Jordi Aguilar
 */
(function webpackUniversalModuleDefinition(root, factory) {
	if(typeof exports === 'object' && typeof module === 'object')
		module.exports = factory();
	else if(typeof define === 'function' && define.amd)
		define([], factory);
	else if(typeof exports === 'object')
		exports["youbora"] = factory();
	else
		root["youbora"] = factory();
})(this, function() {
return /******/ (function(modules) { // webpackBootstrap
/******/ 	// The module cache
/******/ 	var installedModules = {};
/******/
/******/ 	// The require function
/******/ 	function __webpack_require__(moduleId) {
/******/
/******/ 		// Check if module is in cache
/******/ 		if(installedModules[moduleId])
/******/ 			return installedModules[moduleId].exports;
/******/
/******/ 		// Create a new module (and put it into the cache)
/******/ 		var module = installedModules[moduleId] = {
/******/ 			i: moduleId,
/******/ 			l: false,
/******/ 			exports: {}
/******/ 		};
/******/
/******/ 		// Execute the module function
/******/ 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);
/******/
/******/ 		// Flag the module as loaded
/******/ 		module.l = true;
/******/
/******/ 		// Return the exports of the module
/******/ 		return module.exports;
/******/ 	}
/******/
/******/
/******/ 	// expose the modules object (__webpack_modules__)
/******/ 	__webpack_require__.m = modules;
/******/
/******/ 	// expose the module cache
/******/ 	__webpack_require__.c = installedModules;
/******/
/******/ 	// identity function for calling harmony imports with the correct context
/******/ 	__webpack_require__.i = function(value) { return value; };
/******/
/******/ 	// define getter function for harmony exports
/******/ 	__webpack_require__.d = function(exports, name, getter) {
/******/ 		if(!__webpack_require__.o(exports, name)) {
/******/ 			Object.defineProperty(exports, name, {
/******/ 				configurable: false,
/******/ 				enumerable: true,
/******/ 				get: getter
/******/ 			});
/******/ 		}
/******/ 	};
/******/
/******/ 	// getDefaultExport function for compatibility with non-harmony modules
/******/ 	__webpack_require__.n = function(module) {
/******/ 		var getter = module && module.__esModule ?
/******/ 			function getDefault() { return module['default']; } :
/******/ 			function getModuleExports() { return module; };
/******/ 		__webpack_require__.d(getter, 'a', getter);
/******/ 		return getter;
/******/ 	};
/******/
/******/ 	// Object.prototype.hasOwnProperty.call
/******/ 	__webpack_require__.o = function(object, property) { return Object.prototype.hasOwnProperty.call(object, property); };
/******/
/******/ 	// __webpack_public_path__
/******/ 	__webpack_require__.p = "";
/******/
/******/ 	// Load entry module and return exports
/******/ 	return __webpack_require__(__webpack_require__.s = 26);
/******/ })
/************************************************************************/
/******/ ([
/* 0 */
/***/ (function(module, exports, __webpack_require__) {

var Emitter = __webpack_require__(2)

/**
 * Static Log class for YouboraLib
 *
 * @class
 * @static
 * @memberof youbora
 */
var Log = {

  _emitter: new Emitter(),

  /** Exposes {@link youbora.EvenfulObject.on} */
  on: function () { Log._emitter.on.apply(Log._emitter, arguments) },
  /** Exposes {@link youbora.EvenfulObject.off} */
  off: function () { Log._emitter.off.apply(Log._emitter, arguments) },
  /** Exposes {@link youbora.EvenfulObject.emit} */
  emit: function () { Log._emitter.emit.apply(Log._emitter, arguments) },

  /**
   * Enum for log levels
   * @enum
   */
  Level: {
    /** No console outputs */
    SILENT: 6,
    /** Console will show errors */
    ERROR: 5,
    /** Console will show warnings */
    WARNING: 4,
    /** Console will show notices (ie: life-cyrcle logs) */
    NOTICE: 3,
    /** Console will show debug messages (ie: player events) */
    DEBUG: 2,
    /** Console will show verbose messages (ie: Http Requests) */
    VERBOSE: 1
  },

  /**
   * Enum for events
   * @enum
   */
  Event: {
    /** Sent each time a messaged is issued, even if log level does not handle it. */
    LOG: 'log'
  },

  /**
   * Only logs of this imporance or higher will be shown.
   * @default youbora.Log.Levels.ERROR
   * @see {@link youbora.Log.Levels}
   */
  logLevel: 5,

  /**
   * If true, console logs will always be outputed without colors (for debbugin in devices).
   * @default false
   */
  plainLogs: false,

  /**
   * Returns a console message
   *
   * @private
   * @param {(string|error|array)} msg Message string, error object or array of messages.
   * @param {Log.Levels} [level=Log.Levels.NOTICE] Defines the level of the error sent.
   * Only errors with higher or equal level than Log.logLevel will be displayed.
   * @param {string} [color=darkcyan] Color of the header
   * @see {@link Youbora.Log.debugLevel}
   */
  report: function (msg, level, color) {
    if (console && console.log) {
      level = level || Log.Level.NOTICE
      color = color || 'darkcyan'

      var letters = {
        5: 'e', // Error
        4: 'w', // Warning
        3: 'n', // Notice
        2: 'd', // Debug
        1: 'v' // Verbose
      }

      var letter = letters[level]
      var prefix = '[Youbora]' + Log._getCurrentTime() + ' ' + letter + ':'

      this.emit('log', { level: level, msg: msg, prefix: prefix })

      // Show messages in actual console if level is enought
      if (Log.logLevel <= level) {
        if (Log.plainLogs || document.documentMode) { // document.documentMode exits only in IE
          // Plain log for IE and devices
          Log._plainReport(msg, prefix)
        } else {
          // choose log method
          var logMethod
          if (level === Log.Level.ERROR && console.error) {
            logMethod = console.error
          } else if (level === Log.Level.WARNING && console.warn) {
            logMethod = console.warn
          } else if (level === Log.Level.DEBUG && console.debug) {
            logMethod = console.debug
          } else {
            logMethod = console.log
          }

          // print message
          prefix = '%c' + prefix
          if (msg instanceof Array) {
            msg.splice(0, 0, prefix, 'color: ' + color)
            logMethod.apply(console, msg)
          } else {
            logMethod.call(console, prefix, 'color: ' + color, msg)
          }
        }
      }
    }
  },

  /**
   * Returns the current time in format hh:mm:ss.mmm (with trailing 0s)
   * @private
   * @return {string} Current time.
   */
  _getCurrentTime: function () {
    var d = new Date()
    var hh = ('0' + d.getDate()).slice(-2)
    var mm = ('0' + d.getMinutes()).slice(-2)
    var ss = ('0' + d.getSeconds()).slice(-2)
    var mmm = ('00' + d.getMilliseconds()).slice(-3)
    return '[' + hh + ':' + mm + ':' + ss + '.' + mmm + ']'
  },

  /**
   * Returns a console message without style
   *
   * @private
   * @param {(string|object|array)} msg Message string, object or array of messages.
   * @param {string} prefix Prefix of the message.
   */
  _plainReport: function (msg, prefix) {
    if (msg instanceof Array) {
      for (var m in msg) {
        Log._plainReport(msg[m], prefix)
      }
    } else {
      if (typeof msg === 'string') {
        console.log(prefix + ' ' + msg)
      } else {
        console.log(prefix + ' <next line>')
        console.log(msg)
      }
    }
  },

  /**
   * Sends an error (level 1) console log.
   * Supports unlimited arguments: ("this", "is", "a", "message")
   * @memberof $YB
   * @see {@link $YB.report}
   */
  error: function () {
    Log.report([].slice.call(arguments), Log.Level.ERROR, 'darkred')
  },

  /**
   * Sends a warning (level 2) console log.
   * Supports unlimited arguments: ("this", "is", "a", "message")
   * @memberof $YB
   * @see {@link $YB.report}
   */
  warn: function () {
    Log.report([].slice.call(arguments), Log.Level.WARNING, 'darkorange')
  },

  /**
   * Sends a notice (level 3) console log.
   * Supports unlimited arguments: ("this", "is", "a", "message")
   * @memberof $YB
   * @see {@link $YB.report}
   */
  notice: function () {
    Log.report([].slice.call(arguments), Log.Level.NOTICE, 'darkgreen')
  },

  /**
   * Sends a debug message (level 4) to console.
   * Supports unlimited arguments: ("this", "is", "a", "message")
   * @memberof $YB
   * @see {@link $YB.report}
   */
  debug: function () {
    Log.report([].slice.call(arguments), Log.Level.DEBUG, 'indigo')
  },

  /**
   * Sends a verbose message (level 5) to console.
   * Supports unlimited arguments: ("this", "is", "a", "message")
   * @memberof $YB
   * @see {@link $YB.report}
   */
  verbose: function () {
    Log.report([].slice.call(arguments), Log.Level.VERBOSE, 'navy')
  },

  /**
   * This function is automatically executed at youboralib's init.
   * Will search inside window.location.search for attribute 'youbora-debug=X'.
   * X can have one of these values, that will modify LogLevel.
   * 6: SILENT,
   * 5: ERROR,
   * 4: WARNING,
   * 3: NOTICE,
   * 2: DEBUG,
   * 1: VERBOSE
   *
   * If youbora-console=plain is present, plainLogs will be set to true.
   */
  loadLevelFromUrl: function () {
    if (typeof window !== 'undefined' && window.location && window.location.search) {
      var m = /\?.*&*youbora-debug=(.+)/i.exec(window.location.search)
      if (m !== null) {
        Log.logLevel = m[1]
      }

      var m2 = /\?.*&*youbora-debug=plain/i.exec(window.location.search)
      if (m2 !== null) {
        Log.plainLogs = true
      }
    }
  }
}

module.exports = Log


/***/ }),
/* 1 */
/***/ (function(module, exports) {

var YouboraObject = function () {}

YouboraObject.prototype = {
  /**
   * A base class that other Classes should inherit from.
   * It has a no-op constructor intended to be overridden by classes that extend from this.
   *
   * @constructs YouboraObject
   * @abstract
   * @memberof youbora
   */
  constructor: function () {}
}

/**
 * This static method allows the extension of the current class, emulating 1-level inheritance.
 * Also add a helper __super__ object poiting to the parent prototypes methods
 * @see https://github.com/SBoudrias/class-extend
 * @example
 * var A = YouboraObject.extend({ a: 1, b: 1, c: { d: 0 } });
 * var a = new A(); // { a: 1, b: 1, c: { d: 0 } }
 *
 * var B = A.extend({ b: 2, c: { e: 3 } });
 * var b = new B(); // { a: 1, b: 2, c: { e: 3 } }
 *
 * @param  {Object} protoProps  Prototype properties (available on the instances)
 * @param  {Object} staticProps Static properties (available on the contructor)
 * @return {Object}             New sub class
 */
YouboraObject.extend = function (protoProps, staticProps) {
  var parent = this
  var NewClass

  // The constructor function for the new subclass is either defined by you
  // (the "constructor" property in your `extend` definition), or defaulted
  // by us to simply call the parent's constructor.
  if (protoProps && Object.prototype.hasOwnProperty.call(protoProps, 'constructor')) {
    NewClass = protoProps.constructor
  } else {
    NewClass = function () { return parent.apply(this, arguments) }
  }

  // Add static properties to the constructor function, if supplied.
  Object.assign(NewClass, parent, staticProps)

  // Set the prototype chain to inherit from `parent`
  NewClass.prototype = Object.create(parent.prototype, {
    constructor: {
      value: NewClass,
      enumerable: false,
      writable: true,
      configurable: true
    }
  })

  // Add prototype properties (instance properties) to the subclass,
  // if supplied.
  if (protoProps) Object.assign(NewClass.prototype, protoProps)

  // Set a convenience property in case the parent's prototype is needed
  // later.
  NewClass.__super__ = parent.prototype

  return NewClass
}

module.exports = YouboraObject


/***/ }),
/* 2 */
/***/ (function(module, exports, __webpack_require__) {

var YouboraObject = __webpack_require__(1)

/**
 * This class extends YouboraObject, adding event emitting/listening functionalities.
 * @constructs Emitter
 * @extends YouboraObject
 * @memberof youbora
 */
var Emitter = YouboraObject.extend(
  /** @lends Emitter.prototype */
  {
    /**
     * Sets a listener to a given event. Use {@link emit} to trigger those events.
     * Pass '*' to listen ALL events.
     * @param {string} event Name of the event.
     * @param {function} callback Callback of the event. Receives event and data.
     * @return this
     */
    on: function (event, callback) {
      this._listeners = this._listeners || {}
      if (typeof callback === 'function') {
        this._listeners[event] = this._listeners[event] || []
        this._listeners[event].push(callback)
        return this
      }
    },

    /**
     * Removes given callback from the listeners of this object.
     * @param {string} event Name of the event.
     * @param {function} callback Callback of the event.
     * @return this
     */
    off: function (event, callback) {
      this._listeners = this._listeners || {}

      if (this._listeners[event]) {
        var index = this._listeners[event].indexOf(callback)
        if (index !== -1) {
          this._listeners[event].splice(index, 1)
        }
      }
      return this
    },

    /**
     * Emits given event, triggering all the associated callbacks.
     * @param {string} event Name of the event.
     * @param {object} [data] Custom data to be sent to the callbacks.
     * @return this
     */
    emit: function (event, data) {
      this._listeners = this._listeners || {}
      data = data || {}

      if (Array.isArray(this._listeners[event])) {
        this._listeners[event].forEach(this._eachCallback.bind(this, event, data))
      }
      if (Array.isArray(this._listeners['*'])) {
        this._listeners['*'].forEach(this._eachCallback.bind(this, event, data))
      }

      return this
    },

    _eachCallback: function (event, data, callback) {
      if (typeof callback === 'function') {
        callback({ type: event, data: data, target: this })
      }
    }
  }
)

module.exports = Emitter


/***/ }),
/* 3 */
/***/ (function(module, exports, __webpack_require__) {

var YouboraObject = __webpack_require__(1)
var Log = __webpack_require__(0)

var YBRequest = YouboraObject.extend(
  /** @lends YBRequest.prototype */
  {
    /**
     * YBYBRequest class will wrap XmlHttpRequest and extend its functionality, allowing youbora
     * to manage queues, blockers and retries.
     *
     * @constructs YBRequest
     * @extends Object
     * @memberof youbora
     *
     * @param {string} host URL of the request. ie: nqs.nice264.com
     * @param {string} [service] Name of the service. ie '/start'
     * @param {Object} [params] Object of key:value params.
     * @param {Object} [options] Object with custom options.
     * @param {string} [options.method="GET"] Specifies the method of the request. ie: "GET", "HEAD".
     * @param {string} [options.requestHeaders] Object with options of requestHeaders.
     * ie: { header: value }.
     * @param {number} [options.retryAfter=5000] Time in ms before sending a failed request again.
     * 0 to disable.
     * @param {number} [options.maxRetries=3] Max number of retries. 0 to disable.
     * @param {bool} [options.cache=false] If false, timestamp will be added to each request to
     * prevent caching.
     */
    constructor: function (host, service, params, options) {
      /** Instance of XmlHttpRequest (or the item returned by createXHR method). */
      this.xhr = this.createXHR()

      /** Host of the request */
      this.host = host || ''

      /** Service of the request */
      this.service = service || ''

      /** Object of params of the request */
      this.params = params || {}

      /** Options of the request */
      this.options = Object.assign({
        method: 'GET',
        requestHeaders: {},
        maxRetries: 3,
        retryAfter: 5000,
        cache: false
      }, options)

      /** Number of times this request has failed and retried. */
      this.retries = 0

      // Add timemark
      if (!this.options.cache) {
        this.setParam('timemark', new Date().getTime())
      }
    },

    /**
     * Creates XMLHttpRequest if it is available in the browser.
     * If not, it tries to create an ActiveXObject XMLHTTP item.
     * Override this function for custom environments.
     *
     * @return YBRequest handler.
     */
    createXHR: function () {
      try {
        if (XMLHttpRequest) {
          return new XMLHttpRequest()
        } else {
          return new ActiveXObject('Microsoft.XMLHTTP')
        }
      } catch (err) {
        Log.error(err)
        return {}
      }
    },

    /**
     * Returns xhr object.
     *
     * @return {XmlHttpRequest} object.
     */
    getXHR: function () {
      return this.xhr
    },

    /** Returns the complete formed url of the request url+service+params. */
    getUrl: function () {
      return this.host + this.service + this.getParamString()
    },

    /**
     * Wraps this.getHXR.addEventListener.
     * Accepts a callback that receives (this YBRequest, event)
     */
    on: function (event, callback) {
      this.xhr.addEventListener(event, callback.bind(this, this))
      return this
    },

    /** Wraps this.getHXR.removeEventListener */
    off: function (event, callback) {
      this.xhr.removeEventListener(event, callback)
      return this
    },

    /**
     * Returns the params of the request, stringified.
     * ie: '?pluginVersion=5.1.0&systemCode=nicetv'.
     * @return {string} Concatenated Params
     */
    getParamString: function () {
      try {
        var params = '?'
        for (var key in this.params) {
          var param = this.params[key]
          if (param !== null && typeof param === 'object') {
            var string = encodeURIComponent(JSON.stringify(param))
            if (string.length > 2) {
              params += encodeURIComponent(key) + '=' + string + '&'
            }
          } else if (param !== null && typeof param !== 'undefined' && param !== '') {
            params += encodeURIComponent(key) + '=' + encodeURIComponent(param) + '&'
          }
        }
        return params.slice(0, -1)
      } catch (err) {
        Log.error(err)
        return ''
      }
    },

    /**
     * Returns the value of the given param, or undefined.
     * @param {string} key Name of the param.
     * @return {any}
     */
    getParam: function (key) {
      return this.params[key]
    },

    /**
     * Add or set a parameter for the request.
     * ie: if you want to add 'username=user' use setParam('username', 'user').
     * @param {string} key Name of the param.
     * @param {string} value Name of the param.
     * @return this
     */
    setParam: function (key, value) {
      this.params[key] = value
      return this
    },

    /**
     * Sends the request.
     *
     * @return returns xhr.send()
     */
    send: function () {
      try {
        this.xhr.open(this.options.method, this.getUrl(), true)

        // Add custom headers
        if (this.options.requestHeaders) {
          for (var key in this.options.requestHeaders) {
            if (this.options.requestHeaders.hasOwnProperty(key)) {
              this.xhr.setRequestHeader(key, this.options.requestHeaders[key])
            }
          }
        }

        // Add retries system
        if (this.options.retryAfter > 0 && this.options.maxRetries > 0) {
          var genericError = function () {
            if (this.retries >= this.options.maxRetries) {
              Log.error('Aborting failed request "' + this.service + '". Max retries reached.')
            } else {
              Log.warn('YBRequest "' + this.service + '" failed. Retry ' + (this.retries + 1) + ' of ' +
                this.options.maxRetries + ' in ' + this.options.retryAfter + 'ms.')

              setTimeout(function () {
                this.retries += 1
                this.send()
              }.bind(this), this.options.retryAfter)
            }
          }
          if (this.retries === 0) {
            this.on(YBRequest.Event.ERROR, genericError.bind(this))
          }
        }

        // Log XHR
        if (Log.logLevel <= Log.Level.VERBOSE) {
          Log.verbose('XHR Req: ' + this.getUrl())
        }

        // Register 'on every' listeners
        for (var event in YBRequest._globalListeners) {
          YBRequest._globalListeners[event].forEach(function (callback) {
            this.on(event, callback)
          }.bind(this))
        }

        // Send
        return this.xhr.send()
      } catch (err) {
        Log.error(err)
      }
    }
  },

  /** @lends YBRequest */
  {
    /**
     * List of events that could be fired from XHR
     * @enum
     */
    Event: {
      /** Request successful */
      SUCCESS: 'load',
      /** Request successful */
      LOAD: 'load', // Native JS
      /** Request returned error */
      ERROR: 'error',
      /** Request aborted */
      ABORT: 'abort'
    },

    /** @private */
    _globalListeners: {},

    /**
     * Adds a callback to every instance.
     * @param {string} event Name of the event.
     * @param {function} callback Callback of the event.
     */
    onEvery: function (event, callback) {
      YBRequest._globalListeners[event] = YBRequest._globalListeners[event] || []
      YBRequest._globalListeners[event].push(callback)
    },

    /**
     * Removes a global callback
     * @param {string} event Name of the event.
     * @param {function} callback Callback of the event.
     */
    offEvery: function (event, callback) {
      if (YBRequest._globalListeners[event]) {
        var index = YBRequest._globalListeners[event].indexOf(callback)
        if (index !== -1) {
          YBRequest._globalListeners[event].splice(index, 1)
        }
      }
    }
  })

module.exports = YBRequest


/***/ }),
/* 4 */
/***/ (function(module, exports, __webpack_require__) {

var Emitter = __webpack_require__(2)

var Transform = Emitter.extend(
  /** @lends Transform.prototype */

  /**
   * Transform classes among youbora helps the library parse and work with data.
   * ResourceTransform, ViewTransform... all extend from this class.
   *
   * @constructs Transform
   * @extends Emitter
   * @memberof youbora
   * @abstract
   */
  {
    constructor: function () {
      this._isBusy = true
    },

    /**
     * Override this method to transform info.
     *
     * @param {YBRequest} request Request to transform.
     */
    parse: function (request) { },

    /**
     * Returns if transform is blocking.
     *
     * @param {YBRequest} request Request to transform.
     * @return {bool} True if queue shall be blocked.
     */
    isBlocking: function (request) {
      return this._isBusy
    },

    /**
     * Emits DONE event
     */
    done: function () {
      this._isBusy = false
      this.emit(Transform.Event.DONE)
    }
  },

  /** @lends Transform */
  {
    // Static members

    /**
     * List of events that could be fired from this class.
     * @enum
     */
    Event: {
      /** Notifies that this Transform is done processing. */
      DONE: 'done'
    }
  }
)

module.exports = Transform


/***/ }),
/* 5 */
/***/ (function(module, exports) {

/**
 * This static class englobes youbora constants.
 * @class
 * @static
 * @memberof youbora
 */
var Constants = {
  /**
 * List of youbora services.
 * @enum
 */
  Service: {
    DATA: '/data',
    INIT: '/init',
    START: '/start',
    JOIN: '/joinTime',
    PAUSE: '/pause',
    RESUME: '/resume',
    SEEK: '/seek',
    BUFFER: '/bufferUnderrun',
    ERROR: '/error',
    STOP: '/stop',
    PING: '/ping',
    AD_START: '/adStart',
    AD_JOIN: '/adJoin',
    AD_PAUSE: '/adPause',
    AD_RESUME: '/adResume',
    AD_BUFFER: '/adBufferUnerrun',
    AD_STOP: '/adStop'
  }
}

module.exports = Constants


/***/ }),
/* 6 */
/***/ (function(module, exports, __webpack_require__) {

var YouboraObject = __webpack_require__(1)

var Chrono = YouboraObject.extend(
  /** @lends Chrono.prototype */
  {
    /**
     * This class calculates time lapses between two points.
     *
     * @constructs Chrono
     * @extends YouboraObject
     * @memberof youbora
     */
    constructor: function () {
      this.reset()
    },

    /** Reset chrono values. */
    reset: function () {
      /** Start time */
      this.startTime = 0

      /** Stop time */
      this.stopTime = 0

      /** Offset to be added to deltaTime and stop. in ms. */
      this.offset = 0
    },

    /**
     * Returns the time between start() and the last stop() in ms. Returns -1 if start wasn't
     * called.
     * @param {boolean} [stop=true] If true, it will force a stop() if it wasn't called before.
     * @return {number} Time lapse in ms.
     */
    getDeltaTime: function (stop) {
      var now = new Date().getTime()
      if (this.startTime) {
        if (stop && !this.stopTime) { this.stopTime = now }
        return this.offset + (now - this.startTime)
      } else {
        return -1
      }
    },

    /**
     * Starts the chrono.
     */
    start: function () {
      this.startTime = new Date().getTime()
      this.stopTime = 0
    },

    /**
     * Stops the timer and returns current delta time.
     * @return {number} Returns the delta time
     */
    stop: function () {
      this.stopTime = new Date().getTime()
      return this.startTime ? this.offset + (this.stopTime - this.startTime) : -1
    },

    /**
     * Creates a copy of the chrono.
     */
    clone: function () {
      var chrono = new Chrono()
      chrono.startTime = this.startTime
      chrono.stopTime = this.stopTime
      chrono.offset = this.offset
      return chrono
    }
  }
)

module.exports = Chrono


/***/ }),
/* 7 */
/***/ (function(module, exports, __webpack_require__) {

var Log = __webpack_require__(0)

/**
 * This static class provides utilities
 * @class
 * @static
 * @memberof youbora
 */
var Util = {
  /**
   * Strip {protocol}:// and // from the begining of the string.
   *
   * @param {string} url
   * @returns {string} stripped url
   */
  stripProtocol: function (url) {
    try {
      return url.replace(/^(.*?:\/\/|\/\/)/i, '')
    } catch (err) {
      Log.warn(err)
      return url
    }
  },

  /**
   * Adds specific protocol. ie: [http[s]:]//nqs.nice264.com
   *
   * @param {string} url Domain of the service.
   * @param {boolean|null} [httpSecure]
   * If true will add https, if false http.
   * Otherwise will add //
   * @return Return the complete service URL.
   */
  addProtocol: function (url, httpSecure) {
    try {
      if (httpSecure === true) {
        return 'https://' + url
      } else if (window.location.protocol.indexOf('http') === 0) {
        return '//' + url
      } else {
        return 'http://' + url
      }
    } catch (err) {
      Log.warn(err)
      return 'http://localhost/'
    }
  },

  /**
   * Return n if it isn't NaN, negative, Infinity, null or undefined.
   * In any other case, return def.
   *
   * @param {mixed} n Number to be parsed.
   * @param {number} defl Number to return if n is not correct.
   */
  parseNumber: function (n, def) {
    if (
      !isNaN(n) &&
      n >= 0 &&
      n !== Infinity &&
      n !== -Infinity &&
      n !== null &&
      typeof n !== 'undefined'
    ) {
      return n
    } else {
      return def
    }
  },

  /**
   * This utility function will add most of the HTML5 common event listeners to the player sent.
   * This common events will be listened: 'canplay', 'buffering', 'waiting', 'ended', 'play',
   * 'playing', 'pause', 'resume', 'error', 'abort', 'seek', 'seeking', 'seeked', 'stalled',
   * 'dispose', 'loadeddata', 'loadstart'.
   *
   * Events will be reported as DEBUG level messages.
   *
   * @param {object|function} o Object to attach the events.
   * @param {array} [extraEvents]
   * An array of extra events to watch. ie:  ['timeupdate', 'progress'].
   * If the first item is null, no common events will be added.
   * @param {function} [report] Callback function called to report events.
   * Default calls Log.debug()
   */
  logAllEvents: function (o, extraEvents, report) {
    try {
      if (Log.logLevel <= Log.Level.DEBUG) {
        report = report || function (e) {
          Log.debug('Event: ' + e.type)
        }

        var playerEvents = [
          'canplay', 'buffering', 'waiting', 'ended', 'play', 'playing',
          'pause', 'resume', 'error', 'abort', 'seek', 'seeking', 'seeked',
          'stalled', 'dispose', 'loadeddata', 'loadstart'
        ]
        if (extraEvents) {
          if (extraEvents[0] === null) {
            extraEvents.shift()
            playerEvents = extraEvents
          } else {
            playerEvents = playerEvents.concat(extraEvents)
          }
        }

        for (var i = 0; i < playerEvents.length; i++) {
          if (typeof o === 'function') {
            o.call(window, playerEvents[i], report)
          } else if (o.on) {
            o.on(playerEvents[i], report)
          } else if (o.addEventListener) {
            o.addEventListener(playerEvents[i], report)
          }
        }
      }
    } catch (err) {
      Log.error(err)
    }
  },

  /**
   * Builds a string that represents the rendition.
   *
   * The returned string will have the following format: <width>x<height>@bitrate<suffix?>.
   * If either the width or height are < 1, only the bitrate will be returned.
   * If bitrate is < 1, only the dimensions will be returned.
   * If bitrate is < and there is no dimensions, a null will be returned.
   * The bitrate will also have one of the following suffixes dependin on its
   * magnitude: bps, Kbps, Mbps
   *
   * @param {any} width The width of the asset. If only 1 argument is sent, it will be treated
   * as bitrate.
   * @param {any} height The height of the asset.
   * @param {any} bitrate The indicated bitrate (in the manifest) of the asset.
   * @returns {string} A string with the following format: <width>x<height>@<bitrate><suffix>
   */
  buildRenditionString: function (width, height, bitrate) {
    if (arguments.length === 1) {
      bitrate = width
      width = null
      height = null
    }

    var ret = ''
    if (width && height) {
      ret = width + 'x' + height
      if (bitrate > 0) {
        ret += '@'
      }
    }

    if (bitrate < 1) {
      return ret
    } else if (bitrate < 1e3) {
      ret += Math.round(bitrate) + 'bps'
    } else if (bitrate < 1e6) {
      bitrate = Math.round(bitrate / 1e3)
      ret += bitrate + 'Kbps'
    } else {
      bitrate = Math.round(bitrate / 1e4) / 1e2
      ret += bitrate + 'Mbps'
    }

    return ret || null
  },

  /**
   * Returns a params dictionary with the error values.
   *
   * @param {String|Object} [code] Error Code, if an object is sent, it will be treated as params.
   * @param {String} [msg] Error Message
   * @param {Object} [metadata] Object defining error metadata
   * @param {String} [level] Level of the error. Currently supports 'error' and 'fatal'
   * @returns {Object} Key:value params.
   */
  buildErrorParams: function (code, msg, metadata, level) {
    if (typeof code === 'object') {
      return code
    } else {
      var params = {}
      params.errorCode = code || 'PLAY_FAILURE'
      params.errorMsg = msg || params.errorCode
      params.errorMetadata = metadata
      params.errorLevel = level || 'error'
      return params
    }
  }

}

module.exports = Util


/***/ }),
/* 8 */
/***/ (function(module, exports, __webpack_require__) {

var YouboraObject = __webpack_require__(1)
var Chrono = __webpack_require__(6)

var Timer = YouboraObject.extend(
  /** @lends Timer.prototype */
  {
    /**
     * Instances of this class will call a callback every setted interval.
     *
     * @param {function} callback The callback to call every due interval.
     * Callback will receive lapsed ms between calls.
     * @param {int} [interval=5000] Milliseconds between each call.
     *
     * @constructs Timer
     * @extends YouboraObject
     * @memberof youbora
     */
    constructor: function (callback, interval) {
      this.callback = callback
      this.interval = interval || 5000
      this.isRunning = false
      this._timer = null

      this.chrono = new Chrono()
    },

    /**
     * Starts the timer.
     */
    start: function () {
      this.isRunning = true
      this._setTick()
    },

    /**
     * Stops the timer.
     */
    stop: function () {
      this.isRunning = false
      if (this._timer) clearTimeout(this._timer)
    },

    _setTick: function () {
      this.chrono.start()
      this._timer = setTimeout(function () {
        this.callback(this.chrono.stop())
        this._setTick()
      }.bind(this), this.interval)
    }
  }
)

module.exports = Timer


/***/ }),
/* 9 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__(22).version


/***/ }),
/* 10 */
/***/ (function(module, exports, __webpack_require__) {

var Emitter = __webpack_require__(2)
var Log = __webpack_require__(0)
var Util = __webpack_require__(7)
var version = __webpack_require__(9)
var PlaybackChronos = __webpack_require__(23)
var PlaybackFlags = __webpack_require__(24)
var PlayheadMonitor = __webpack_require__(11)

var Adapter = Emitter.extend(
  /** @lends Adapter.prototype */
  {
    /**
     * This class is the basic adapter from which specific adapters will extend.
     * It receives a player: If it is an object, it will be saved as this.player.
     * It it is a string, it will be saved as this.player = document.getElementById(...)
     * Will call registerListeners()
     *
     * @constructs Adapter
     * @extends Emitter
     * @memberof youbora
     *
     * @param {object|string} player Either an instance of the player or a string containing an ID.
     */
    constructor: function (player) {
      /** An instance of {@link FlagStatus} */
      this.flags = new PlaybackFlags()

      /** An instance of {@link ChronoStatus} */
      this.chronos = new PlaybackChronos()

      /** Reference to {@link PlayheadMonitor}. Helps the plugin detect buffers/seeks. */
      this.monitor = null

      /** Reference to {@link Plugin}. */
      this.plugin = null

      /** Reference to the player tag */
      this.player = null

      // Register player and event listeners
      this.setPlayer(player)

      /** Reference to the video/object tag, could be the same as the player. */
      this.tag = this.player

      Log.notice('Adapter ' + this.getVersion() + ' with Lib ' + version + ' is ready.')

      this.emit(Adapter.Event.READY)
    },

    /**
     * Sets a new player, removes the old listeners if needed.
     *
     * @param {Object} player Player to be registered.
     */
    setPlayer: function (player) {
      if (this.player) this.unregisterListeners()

      if (typeof player === 'string') {
        this.player = document.getElementById(player)
      } else {
        this.player = player
      }

      if (this.player) this.registerListeners()
    },

    /**
     * Override to create event binders.
     * @example
     * registerListeners: function () {
     *  this.player.addEventListener('start', this.onStart.bind(this))
     * },
     * onStart: function (e) {
     *  this.emit('start')
     * }
     */
    registerListeners: function () { },

    /**
     * Override to create event de-binders.
     * @example
     * registerListeners: function () {
     *  this.player.removeEventListener('start', this.onStart)
     * }
     */
    unregisterListeners: function () { },

    /**
     * This function disposes the currend adapter, removes player listeners and drops references.
     */
    dispose: function () {
      if (this.monitor) this.monitor.stop()
      this.fireStop()
      this.unregisterListeners()
      this.player = null
      this.tag = null
    },

    /**
     * Creates a {@link PlayheadMonitor} at this.monitor.
     *
     * @param {bool} monitorBuffers If true, it will monitor buffers.
     * @param {bool} monitorSeeks If true, it will monitor seeks.
     * @param {number} [interval=800] The interval time in ms.
     */
    monitorPlayhead: function (monitorBuffers, monitorSeeks, interval) {
      var type = 0
      if (monitorBuffers) type |= PlayheadMonitor.Type.BUFFER
      if (monitorSeeks) type |= PlayheadMonitor.Type.SEEK

      this.monitor = new PlayheadMonitor(this, type, interval)
    },

    // GETTERS //

    /** Override to return current playhead of the video */
    getPlayhead: function () {
      return null
    },

    /** Override to return current playrate */
    getPlayrate: function () {
      return !this.flags.isPaused ? 1 : 0
    },

    /** Override to return Frames Per Secon (FPS) */
    getFramesPerSecond: function () {
      return null
    },

    /** Override to return dropped frames since start */
    getDroppedFrames: function () {
      return null
    },

    /** Override to return video duration */
    getDuration: function () {
      return null
    },

    /** Override to return current bitrate */
    getBitrate: function () {
      return null
    },

    /** Override to return user bandwidth throughput */
    getThroughput: function () {
      return null
    },

    /** Override to return rendition */
    getRendition: function () {
      return null
    },

    /** Override to return title */
    getTitle: function () {
      return null
    },

    /** Override to return title2 */
    getTitle2: function () {
      return null
    },

    /** Override to recurn true if live and false if VOD */
    getIsLive: function () {
      return null
    },

    /** Override to return resource URL. */
    getResource: function () {
      return null
    },

    /** Override to return player version */
    getPlayerVersion: function () {
      return null
    },

    /** Override to return player's name */
    getPlayerName: function () {
      return null
    },

    /** Override to return adapter version. */
    getVersion: function () {
      return version + '-generic-js'
    },

    /** Override to return current ad position (only ads) */
    getPosition: function () {
      return null
    },

    // FLOW //

    /**
     * Emits related event and set flags if current status is valid.
     * ie: won't sent start if isStarted is already true.
     *
     * @param {Object} [params] Object of key:value params.
     */
    fireStart: function (params) {
      if (!this.flags.isStarted) {
        this.flags.isStarted = true

        this.chronos.total.start()
        this.chronos.join.start()

        this.emit(Adapter.Event.START, { params: params })
      }
    },

    /**
     * Emits related event and set flags if current status is valid.
     * ie: won't sent start if isStarted is already true.
     *
     * @param {Object} [params] Object of key:value params.
     */
    fireJoin: function (params) {
      if (this.flags.isStarted && !this.flags.isJoined) {
        if (this.monitor) this.monitor.start()

        this.flags.isJoined = true

        this.chronos.join.stop()

        this.emit(Adapter.Event.JOIN, { params: params })
      }
    },

    /**
     * Emits related event and set flags if current status is valid.
     * ie: won't sent start if isStarted is already true.
     *
     * @param {Object} [params] Object of key:value params.
     */
    firePause: function (params) {
      if (this.flags.isJoined && !this.flags.isPaused) {
        this.flags.isPaused = true

        this.chronos.pause.start()

        this.emit(Adapter.Event.PAUSE, { params: params })
      }
    },

    /**
     * Emits related event and set flags if current status is valid.
     * ie: won't sent start if isStarted is already true.
     *
     * @param {Object} [params] Object of key:value params.
     */
    fireResume: function (params) {
      if (this.flags.isJoined && this.flags.isPaused) {
        this.flags.isPaused = false

        this.chronos.pause.stop()

        if (this.monitor) this.monitor.skipNextTick()

        this.emit(Adapter.Event.RESUME, { params: params })
      }
    },

    /**
     * Emits related event and set flags if current status is valid.
     * ie: won't sent start if isStarted is already true.
     *
     * @param {Object} [params] Object of key:value params.
     * @param {bool} [convertFromSeek=false] If true, will convert current seek to buffer.
     */
    fireBufferBegin: function (params, convertFromSeek) {
      if (this.flags.isJoined && !this.flags.isBuffering) {
        if (this.flags.isSeeking) {
          if (convertFromSeek) {
            Log.notice('Converting current buffer to seek')

            this.chronos.buffer = this.chronos.seek.clone()
            this.chronos.seek.reset()

            this.flags.isSeeking = false
          } else {
            return
          }
        } else {
          this.chronos.buffer.start()
        }

        this.flags.isBuffering = true
        this.emit(Adapter.Event.BUFFER_BEGIN, { params: params })
      }
    },

    /**
     * Emits related event and set flags if current status is valid.
     * ie: won't sent start if isStarted is already true.
     *
     * @param {Object} [params] Object of key:value params.
     */
    fireBufferEnd: function (params) {
      if (this.flags.isJoined && this.flags.isBuffering) {
        this.flags.isBuffering = false

        this.chronos.buffer.stop()

        if (this.monitor) this.monitor.skipNextTick()

        this.emit(Adapter.Event.BUFFER_END, { params: params })
      }
    },

    /**
     * Emits related event and set flags if current status is valid.
     * ie: won't sent start if isStarted is already true.
     *
     * @param {Object} [params] Object of key:value params.
     * @param {bool} [convertFromBuffer=true] If false, will convert current buffer to seek.
     */
    fireSeekBegin: function (params, convertFromBuffer) {
      if (this.flags.isJoined && !this.flags.isSeeking) {
        if (this.flags.isBuffering) {
          if (convertFromBuffer !== false) {
            Log.notice('Converting current buffer to seek')

            this.chronos.seek = this.chronos.buffer.clone()
            this.chronos.buffer.reset()

            this.flags.isBuffering = false
          } else {
            return
          }
        } else {
          this.chronos.seek.start()
        }

        this.flags.isSeeking = true
        this.emit(Adapter.Event.SEEK_BEGIN, { params: params })
      }
    },

    /**
     * Emits related event and set flags if current status is valid.
     * ie: won't sent start if isStarted is already true.
     *
     * @param {Object} [params] Object of key:value params.
     */
    fireSeekEnd: function (params) {
      if (this.flags.isJoined && this.flags.isSeeking) {
        this.flags.isSeeking = false

        this.chronos.seek.stop()

        if (this.monitor) this.monitor.skipNextTick()

        this.emit(Adapter.Event.SEEK_END, { params: params })
      }
    },

    /**
     * Emits related event and set flags if current status is valid.
     * ie: won't sent start if isStarted is already true.
     *
     * @param {Object} [params] Object of key:value params.
     */
    fireStop: function (params) {
      if (this.flags.isStarted) {
        if (this.monitor) this.monitor.stop()

        this.flags.reset()

        this.chronos.total.stop()
        this.chronos.join.reset()
        this.chronos.pause.reset()
        this.chronos.buffer.reset()
        this.chronos.seek.reset()

        this.emit(Adapter.Event.STOP, { params: params })
      }
    },

    /**
     * Emits related event and set flags if current status is valid.
     * ie: won't sent start if isStarted is already true.
     *
     * @param {String|Object} [code] Error Code, if an object is sent, it will be treated as params.
     * @param {String} [msg] Error Message
     * @param {Object} [metadata] Object defining error metadata
     * @param {String} [level] Level of the error. Currently supports 'error' and 'fatal'
     */
    fireError: function (code, msg, metadata, level) {
      var params = Util.buildErrorParams(code, msg, metadata, level)
      this.emit(Adapter.Event.ERROR, { params: params })
    },

    /**
     * Emits related event and set flags if current status is valid.
     * ie: won't sent start if isStarted is already true.
     *
     * @param {String|Object} [code] Error Code, if an object is sent, it will be treated as params.
     * @param {String} [msg] Error Message
     * @param {Object} [metadata] Object defining error metadata
     */
    fireFatalError: function (code, msg, metadata) {
      if (this.monitor) this.monitor.stop()

      this.fireError(code, msg, metadata, 'fatal')
      this.fireStop()
    }
  },

  /** @lend Adapter */
  {
    // Static Memebers //

    /**
     * List of events that could be fired
     * @enum
     */
    Event: {
      READY: 'ready',

      START: 'start',
      JOIN: 'join',
      PAUSE: 'pause',
      RESUME: 'resume',
      SEEK_BEGIN: 'seek-begin',
      SEEK_END: 'seek-end',
      BUFFER_BEGIN: 'buffer-begin',
      BUFFER_END: 'buffer-end',
      ERROR: 'error',
      FATAL_ERROR: 'fatal-error',
      STOP: 'stop'
    }
  }
)

module.exports = Adapter


/***/ }),
/* 11 */
/***/ (function(module, exports, __webpack_require__) {

var YouboraObject = __webpack_require__(1)
var Timer = __webpack_require__(8)
var Chrono = __webpack_require__(6)
// var Log = require('../log')

var PlayheadMonitor = YouboraObject.extend(
  /** @lends PlayheadMonitor.prototype */
  {
    /**
     * This Class store youbora configuration settings.
     *
     * @constructs PlayheadMonitor
     * @extends YouboraObject
     * @memberof youbora
     *
     * @param {Adapter} adapter Adapter to monitor. Must have getPlayhead defined.
     * @param {PlayheadMonitor.Type} [type=NONE]
     * Which metric to monitor seek and/or buffer.
     * Use bitwise operators to join both values (Type.BUFFER | Type.SEEK)
     * @param {int} [interval=800] How many ms will wait between progress. -1 to disable.
     */
    constructor: function (adapter, type, interval) {
      this._adapter = adapter
      this._seekEnabled = type & PlayheadMonitor.Type.SEEK
      this._bufferEnabled = type & PlayheadMonitor.Type.BUFFER
      interval = interval || 800

      this._chrono = new Chrono()
      this._lastPlayhead = 0

      if (interval > 0) {
        this._timer = new Timer(this.progress.bind(this), interval)
      }
    },

    /**
     * Start interval checks.
     */
    start: function () {
      this._timer.start()
    },

    /**
     * Stop interval checks.
     */
    stop: function () {
      if (this._timer) this._timer.stop()
    },

    skipNextTick: function () {
      this._lastPlayhead = 0
    },

    /**
     * Call this method at every tick of timeupdate/progress.
     * If you defined an interval, do not fire this method manually.
     */
    progress: function () {
      // Reset timer
      var deltaTime = this._chrono.stop()
      this._chrono.start()

      // Define thresholds
      var bufferThreshold = deltaTime * PlayheadMonitor.kBUFFER_THRESHOLD_RATIO
      var seekThreshold = deltaTime * PlayheadMonitor.kSEEK_THRESHOLD_RATIO

      // Calculate diff playhead
      var currentPlayhead = this._getPlayhead()
      var diffPlayhead = Math.abs(this._lastPlayhead - currentPlayhead) * 1000

      // Log.debug('curr: ' + currentPlayhead +
      //   ' last: ' + this._lastPlayhead +
      //   ' diff: ' + diffPlayhead)

      if (diffPlayhead < bufferThreshold) {
        // Playhead is stalling > buffer
        if (this._bufferEnabled &&
          this._lastPlayhead > 0 &&
          !this._adapter.flags.isPaused &&
          !this._adapter.flags.isSeeking
        ) {
          this._adapter.fireBufferBegin(null, false)
        }
      } else if (diffPlayhead > seekThreshold) {
        // Playhead has jumped > seek
        if (this._seekEnabled && this._lastPlayhead > 0) {
          this._adapter.fireSeekBegin(null, false)
        }
      } else {
        // Healthy
        if (this._seekEnabled) {
          this._adapter.fireSeekEnd()
        } else if (
          this._bufferEnabled) {
          this._adapter.fireBufferEnd()
        }
      }

      // Update Playhead
      this._lastPlayhead = currentPlayhead
    },
    /**
     * Returns adapter's playhead. Override to add a custom playhead getter.
     * @private
     * @returns {double} Playhead in seconds
     */
    _getPlayhead: function () {
      return this._adapter.getPlayhead()
    }
  }, {
    // Static methods

    /**
     * Enum for monitoring type
     * @enum
     */
    Type: {
      /** Would not monitor */
      NONE: 0,
      /** Sends buffer-begin/end */
      BUFFER: 1,
      /** Sends seek-begin/end */
      SEEK: 2
    },

    /** Buffer threshold */
    kBUFFER_THRESHOLD_RATIO: 0.5,

    /** Seek threshold */
    kSEEK_THRESHOLD_RATIO: 2
  })

module.exports = PlayheadMonitor


/***/ }),
/* 12 */
/***/ (function(module, exports, __webpack_require__) {

var YouboraObject = __webpack_require__(1)
var Log = __webpack_require__(0)
var YBRequest = __webpack_require__(3)
var Transform = __webpack_require__(4)

var Communication = YouboraObject.extend(
  /** @lends Communication.prototype */
  {
    /**
     * Youbora Communication implements an abstraction layer over API requests.
     * Internally, Communication implements queues of {@link Request} objects.
     * This queue can be blocked using {@link Transform}
     *
     * @constructs Communication
     * @extends YouboraObject
     * @memberof youbora
     *
     * @param {string} host The fastdata host address.
     * @param {boolean} httpSecure True for https, false for http, undefined for //.
     */
    constructor: function () {
      /** Array of {@link Transform}, only when the array is empty the request Queues will begin sending. */
      this.transforms = []

      /**
       * Queue of {@link YBRequest}
       * @private
       */
      this._requests = []
    },

    /**
     * Enqueues the request provided.
     *
     * @param {YBRequest} request Request to be enqueued
     * @param {function} [callback] The defined load callback to the Request
     */
    sendRequest: function (request, callback) {
      if (request) {
        if (typeof callback === 'function') request.on(YBRequest.Event.SUCCESS, callback)
        this._registerRequest(request)
      }
    },

    /**
     * Build a generic request to the given host.
     *
     * @param {string} host Host of the service called.
     * @param {string} service A string with the service to be called. ie: '/data', '/joinTime'...
     * @param {Object} [params] Object of key:value params.
     * @param {function} [callback] The defined load callback to the Request
     */
    buildRequest: function (host, service, params, callback) {
      params = params || {}
      var request = new YBRequest(host, service, params)
      if (typeof callback === 'function') request.on(YBRequest.Event.SUCCESS, callback)
      this._registerRequest(request)
    },

    /**
     * Adds a Transform to the queue. See {@link Transform}.
     *
     * @param {RequestTransform} transform
     */
    addTransform: function (transform) {
      if (transform.parse && transform.isBlocking) {
        this.transforms.push(transform)
        transform.on(Transform.Event.DONE, this._processRequests.bind(this))
      } else {
        Log.warn(transform + ' is not a valid RequestTransform.')
      }
    },

    /**
     * Removes a {@link Transform}.
     *
     * @param {RequestTransform} transform Transform object to remove.
     */
    removeTransform: function (transform) {
      var pos = this.transforms.indexOf(transform)
      if (pos !== -1) {
        this.transforms.splice(pos, 1)
      } else {
        Log.warn('Trying to remove unexisting Transform \'' + transform + '\'.')
      }
    },

    /**
     * Adds an {@link YBRequest} to the queue of requests.
     *
     * @private
     * @param {YBRequest} request The Request to be queued.
     */
    _registerRequest: function (request) {
      this._requests.push(request)
      this._processRequests()
    },

    /**
     * Execute pending requests in the queue. Returns rejected ones to the queue.
     * @private
     */
    _processRequests: function () {
      var workingQueue = this._requests
      this._requests = []

      var rejected = []
      while (workingQueue.length) {
        var request = workingQueue.shift()
        if (this._transform(request)) {
          request.send()
        } else {
          rejected.push(request)
        }
      }

      while (rejected.length) {
        this._requests.push(rejected.shift())
      }
    },

    /**
     * Pass the given request to each transform.
     * @private
     * @returns {bool} True if everything is right. False if some parser rejected it.
     */
    _transform: function (request) {
      var ret = true
      this.transforms.forEach(function (transform) {
        if (transform.isBlocking(request)) {
          ret = false
          return // break foreach loop
        } else {
          transform.parse(request)
        }
      })
      return ret
    }
  })

module.exports = Communication


/***/ }),
/* 13 */
/***/ (function(module, exports, __webpack_require__) {

var Transform = __webpack_require__(4)
var Constants = __webpack_require__(5)

var Nqs6Transform = Transform.extend(
  /** @lends Nqs6Transform.prototype */
  {
    /**
     * This class ensures NQS6 retrocompatibility
     *
     * @constructs
     * @extends Transform
     * @memberof youbora
     */
    constructor: function () {
      this.done()
    },

    /**
     * Transform requests
     * @param {YBRequest} request YBRequest to transform.
     */
    parse: function (request) {
      this._cloneParam(request, 'accountCode', 'system')
      this._cloneParam(request, 'transactionCode', 'transcode')
      this._cloneParam(request, 'username', 'user')
      this._cloneParam(request, 'mediaResource', 'resource')
      this._cloneParam(request, 'errorMsg', 'msg')

      if (request.service !== Constants.Service.JOIN) {
        this._cloneParam(request, 'playhead', 'time')
      }

      switch (request.service) {
        case Constants.Service.START:
          this._cloneParam(request, 'mediaDuration', 'duration')
          break

        case Constants.Service.JOIN:
          this._cloneParam(request, 'joinDuration', 'time')
          this._cloneParam(request, 'playhead', 'eventTime')
          break

        case Constants.Service.SEEK:
          this._cloneParam(request, 'seekDuration', 'duration')
          break

        case Constants.Service.BUFFER:
          this._cloneParam(request, 'bufferDuration', 'duration')
          break

        case Constants.Service.PING:
          for (var key in request.params.entities) {
            request.params.entityType = key
            request.params.entityValue = request.params.entities[key]
            break
          }
          break
      }
    },

    _cloneParam: function (request, from, to) {
      request.params[to] = request.params[from]
    }
  })

module.exports = Nqs6Transform


/***/ }),
/* 14 */
/***/ (function(module, exports, __webpack_require__) {

var Transform = __webpack_require__(4)
var HlsParser = __webpack_require__(16)
var CdnParser = __webpack_require__(15)
var Log = __webpack_require__(0)
var Constants = __webpack_require__(5)

var ResourceTransform = Transform.extend(
  /** @lends ResourceTransform.prototype */
  {
    /**
     * This class parses resource to fetch transportstreams, CDNs and Node plugin.
     *
     * @constructs ResourceTransform
     * @extends Transform
     * @memberof youbora
     *
     * @param {Plugin} plugin Instance of {@link Plugin}
     */
    constructor: function (plugin) {
      ResourceTransform.__super__.constructor.apply(this, arguments)

      this._plugin = plugin

      this._realResource = null
      this._initResource = null
      this._cdnName = null
      this._cdnNodeHost = null
      this._cdnNodeTypeString = null
      this._cdnNodeType = null
      this._responses = {}

      this._isBusy = false
    },

    getResource: function () {
      return this._realResource || this._initResource
    },

    getCdnName: function () {
      return this._cdnName
    },

    getNodeHost: function () {
      return this._cdnNodeHost
    },

    getNodeTypeString: function () {
      return this._cdnNodeTypeString
    },

    getNodeType: function () {
      return this._cdnNodeType
    },

    init: function (resource) {
      if (!this._isBusy) {
        this._isBusy = true

        this._initResource = resource

        CdnParser.setBalancerHeaderName(this._cdnNameHeader)
        this._hlsEnabled = this._plugin.isParseHls()
        this._cdnEnabled = this._plugin.isParseCdnNode()
        this._cdnList = this._plugin.getParseCdnNodeList().slice() // clone
        this._cdnNameHeader = this._plugin.getParseCdnNodeNameHeader()

        this._setTimeout()

        if (this._hlsEnabled) {
          this._parseHLS()
        } else if (this._cdnEnabled) {
          this._parseCDN()
        } else {
          this.done()
        }
      }
    },

    _setTimeout: function () {
      // Abort operation after 3s
      this._parseTimeout = setTimeout(function () {
        if (this._isBusy) {
          this.done()
          Log.warn(
            'ResourceTransform has exceded the maximum execution time (3s) and will be aborted.'
          )
        }
      }.bind(this), 3000)
    },

    _parseHLS: function () {
      var hlsTransform = new HlsParser()
      hlsTransform.on(HlsParser.Event.DONE, function () {
        this._realResource = this._hlsTransform.getResource()
        if (this._cdnEnabled) {
          this._parseCDN()
        } else {
          this.done()
        }
      }.bind(this))
      hlsTransform.parse(this._initResource)
    },

    _parseCDN: function () {
      if (this._cdnList.length > 0) {
        var cdn = this._cdnList.pop()

        if (this.getNodeHost()) this.done()

        var cdnParser = CdnParser.create(cdn)

        if (cdnParser) {
          cdnParser.on(CdnParser.Event.DONE, function () {
            this._responses = cdnParser.getResponses()
            this._cdnName = cdnParser.getCdnName()
            this._cdnNodeHost = cdnParser.getNodeHost()
            this._cdnNodeTypeString = cdnParser.getNodeTypeString()
            this._cdnNodeType = cdnParser.getNodeType()

            if (this.getNodeHost()) this.done()
          }.bind(this))
          cdnParser.parse(this.getResource(), this._responses)
        } else {
          this._parseCDN()
        }
      }
    },

    /**
     * Transform requests
     * @param {YBRequest} request YBRequest to transform.
     */
    parse: function (request) {
      if (request.service === Constants.Service.START) {
        var lastSent = this._plugin.requestBuilder.lastSent
        lastSent.mediaResource = request.params.mediaResource = this.getResource()

        if (this._cdnEnabled) {
          lastSent.cdn = request.params.cdn = request.params.cdn || this.getCdnName()
          lastSent.nodeHost = request.params.nodeHost = this.getNodeHost()
          lastSent.nodeType = request.params.nodeType = this.getNodeType()
          lastSent.nodeTypeString = request.params.nodeTypeString = this.getNodeTypeString()
        }
      }
    }
  })

module.exports = ResourceTransform


/***/ }),
/* 15 */
/***/ (function(module, exports, __webpack_require__) {

var Emitter = __webpack_require__(2)
var Log = __webpack_require__(0)
var YBRequest = __webpack_require__(3)

var CdnParser = Emitter.extend(
  /** @lends CdnParser.prototype */
  {
    /**
     * This class helps ResourceTransform parse CDN Nodes.
     *
     * @constructs CdnParser
     * @extends Emitter
     * @memberof youbora
     */
    constructor: function (options) {
      this._options = Object.assign({
        cdnName: null,
        parsers: [],
        requestHeaders: {},
        parseType: function () { return 0 }
      }, options)

      this._responses = {}
    },

    /**
     * Emits DONE event
     */
    done: function () {
      this.emit(CdnParser.Event.DONE)
    },

    addParser: function (parser) {
      this._options.parsers.push(parser)
      return this
    },

    setCdnName: function (name) {
      this._options.cdnName = name
      return this
    },

    setRequestHeader: function (key, value) {
      this._options.requestHeaders[key] = value
      return this
    },

    setParseType: function (parser) {
      this._options.parseType = parser
      return this
    },

    getCdnName: function () {
      return this._cdnName
    },

    getNodeHost: function () {
      return this._cdnNodeHost
    },

    getNodeTypeString: function () {
      return this._cdnNodeTypeString
    },

    getNodeType: function () {
      return this._cdnNodeType
    },

    getResponses: function () {
      return this._responses
    },

    /**
     * Parses given headers to check for matches.
     */
    parse: function (url, responses) {
      this._responses = responses || {}
      var headerString = JSON.stringify(this._options.requestHeaders)
      if (this._responses[headerString]) {
        this._parseResponse(this._responses[headerString])
      } else {
        this._requestResponse(url)
      }
    },

    _requestResponse: function (url) {
      var headerString = JSON.stringify(this._options.requestHeaders)

      var request = new YBRequest(url, null, null, {
        method: 'HEAD',
        maxRetries: 0,
        requestHeaders: this._options.requestHeaders
      })

      request.on(YBRequest.Event.SUCCESS, function (resp) {
        this._responses[headerString] = resp.getXHR().getAllResponseHeaders()
        this._parseResponse(this._responses[headerString])
      }.bind(this))

      request.on(YBRequest.Event.ERROR, function (resp) {
        this.done()
      }.bind(this))

      request.send()
    },

    _parseResponse: function (headers) {
      this._options.parsers.forEach(function (parser) {
        headers.split('\n').forEach(function (line) {
          var index = line.indexOf(':')
          if (index !== -1) {
            var key = line.slice(0, index)
            if (key === parser.headerName) {
              this._executeParser(parser, line.slice(index + 1))
            }
          }
        }.bind(this))
      }.bind(this))
      this.done()
    },

    _executeParser: function (parser, value) {
      try {
        var matches = parser.regex.exec(value.trim())
        if (matches !== null) {
          if (this._options.cdnName) this._cdnName = this._options.cdnName
          switch (parser.element) {
            case 'host':
              this._cdnNodeHost = matches[1]
              break
            case 'type':
              this._cdnNodeTypeString = matches[1]
              this._cdnNodeType = this._options.parseType(this._cdnNodeTypeString)
              break
            case 'host+type':
              this._cdnNodeHost = matches[1]
              this._cdnNodeTypeString = matches[2]
              this._cdnNodeType = this._options.parseType(this._cdnNodeTypeString)
              break
            case 'type+host':
              this._cdnNodeTypeString = matches[1]
              this._cdnNodeType = this._options.parseType(this._cdnNodeTypeString)
              this._cdnNodeHost = matches[2]
              break
            case 'name':
              this._cdnName = matches[1].toUpperCase()
              break
          }
        }
      } catch (err) {
        Log.warn('CDN parsing for ' + this._options.cdnName +
          ' could not parse header value ' + value)
      }
    }

  },

  /** @lends CdnParser */
  {
    // Static members

    /**
     * List of events that could be fired from this class.
     * @enum
     */
    Event: {
      /** Notifies that this CdnParser is done processing. */
      DONE: 'done'
    },

    // Static members
    _cdns: {
      Level3: {
        cdnName: 'LEVEL3',
        parsers: [{
          element: 'host+type',
          headerName: 'X-WR-DIAG',
          regex: /Host:(.+)\sType:(.+)/
        }],
        requestHeaders: {
          'X-WR-DIAG': 'host'
        },
        parseType: function (type) {
          switch (type) {
            case 'TCP_HIT':
            case 'TCP_MEM_HIT':
            case 'TCP_IMS_HIT':
              return 1
            case 'TCP_MISS':
              return 2
            default:
              return 0
          }
        }
      },
      Cloudfront: {
        cdnName: 'CLOUDFRT',
        parsers: [{
          element: 'host',
          headerName: 'X-Amz-Cf-Id',
          regex: /(.+)/
        }, {
          element: 'type',
          headerName: 'X-Cache',
          regex: /(\S+)\s.+/
        }],
        parseType: function (type) {
          switch (type) {
            case 'Hit':
              return 1
            case 'Miss':
              return 2
            default:
              return 0
          }
        }
      },
      Akamai: {
        cdnName: 'AKAMAI',
        parsers: [{
          element: 'type+host',
          headerName: 'X-Cache',
          regex: /(.+)\sfrom\s.+\(.+\/(.+)\).*/
        }],
        parseType: function (type) {
          switch (type) {
            case 'TCP_HIT':
              return 1
            case 'TCP_MISS':
              return 2
            default:
              return 0
          }
        }
      },
      Highwinds: {
        cdnName: 'HIGHNEGR',
        parsers: [{
          element: 'host+type',
          headerName: 'X-HW',
          regex: /.+,[0-9]+\.(.+)\.(.+)/
        }],
        parseType: function (type) {
          switch (type) {
            case 'c':
            case 'x':
              return 1
            default:
              return 2
          }
        }
      },
      Fastly: {
        cdnName: 'FASTLY',
        parsers: [{
          element: 'host',
          headerName: 'X-Served-By',
          regex: /([^,\s]+)$/
        }, {
          element: 'type',
          headerName: 'X-Cache',
          regex: /([^,\s]+)$/
        }],
        parseType: function (type) {
          switch (type) {
            case 'HIT':
              return 1
            case 'MISS':
              return 2
            default:
              return 0
          }
        }
      },
      Balancer: {
        parsers: [{
          element: 'name',
          headerName: null,
          regex: /(.+)/
        }]
      }
    },

    setBalancerHeaderName: function (name) {
      CdnParser._cdns.Balancer.parsers[0].headerName = name
    },

    create: function (key) {
      if (CdnParser._cdns[key]) {
        return new CdnParser(CdnParser._cdns[key])
      } else {
        Log.warn('Tried to create an unexisting CdnParser named ' + key)
      }
    },

    add: function (key, parser) {
      CdnParser._cdns[key] = parser
    }
  }
)

module.exports = CdnParser


/***/ }),
/* 16 */
/***/ (function(module, exports, __webpack_require__) {

var YBRequest = __webpack_require__(3)
var Emitter = __webpack_require__(2)
var Log = __webpack_require__(0)

var HlsParser = Emitter.extend(
  /** @lends HlsParser.prototype */
  {
    /**
     * Extend this class to implement your own ResourceEmitter parser task.
     *
     * @constructs HlsParser
     * @extends Emitter
     * @memberof youbora
     * @abstract
     */
    constructor: function () {
      this._realResource = null
    },

    /**
     * Emits DONE event
     */
    done: function () {
      this.emit(HlsParser.Event.DONE)
    },

    /**
     *
     *
     * @param {string} resource Either the resource url or the manifest body.
     * @param {string} parentResource Parent resource in case relative paths are sent.
     */
    parse: function (resource, parentResource) {
      parentResource = parentResource || ''

      try {
        var matches = /((\S*?)(\.m3u8|\.m3u|\.ts|\.mp4)(\?\S*|\n|\r|$))/i.exec(resource)
      } catch (err) {
        Log.warn('Parse HLS Regex failed', err)
        this.done()
      }

      if (matches !== null) { // get first line ending in .m3u8, .m3u, .mp4 or .ts
        var res = matches[1].trim()

        var index = parentResource.lastIndexOf('/')
        if (res.indexOf('http') !== 0 && index !== -1) {
          // If does not start with http, add parentResource relative route.
          res = parentResource.slice(0, index) + '/' + res
        }

        if (matches[3] === '.m3u8' || matches[3] === '.m3u') { // It is m3u8 or m3u...
          var request = new YBRequest(res, null, null, { cache: true })

          request.on(YBRequest.Event.SUCCESS, function (resp) {
            this.parse(resp.getXHR().responseText, matches[2])
          }.bind(this))

          request.on(YBRequest.Event.ERROR, function (resp) {
            this.done()
          }.bind(this))

          request.send()
        } else { // It is mp4 or ts...
          this._realResource = res
          this.done()
        }
      } else {
        this.done()
      }
    },

    getResource: function () {
      return this._realResource
    }
  },

  /** @lends HlsParser */
  {
    // Static members

    /**
     * List of events that could be fired from this class.
     * @enum
     */
    Event: {
      /** Notifies that this HlsParser is done processing. */
      DONE: 'done'
    }
  }
)

module.exports = HlsParser


/***/ }),
/* 17 */
/***/ (function(module, exports, __webpack_require__) {

var YBRequest = __webpack_require__(3)
var Transform = __webpack_require__(4)
var Log = __webpack_require__(0)
var Util = __webpack_require__(7)
var Constants = __webpack_require__(5)

var ViewTransform = Transform.extend(
  /** @lends ViewTransform.prototype */
  {
    /**
     * This class manages Fastdata service and view index.
     *
     * @constructs
     * @extends Transform
     * @memberof youbora
     *
     * @param {Plugin} plugin Instance of {@link Plugin}
     */
    constructor: function (plugin) {
      Transform.prototype.constructor.apply(this, arguments)

      /** /data response */
      this.response = {}

      this._viewIndex = -1

      var service = Constants.Service.DATA
      var params = {
        apiVersion: 'v6,v7',
        outputformat: 'jsonp'
      }

      params = plugin.requestBuilder.buildParams(params, service)
      if (params !== null) {
        Log.notice(service + ' ' + params.system)
        if (params.system === 'nicetest') {
          Log.error(
            'No accountCode has been set. Please set your accountCode inside plugin\'s options.'
          )
        }

        this._request = new YBRequest(plugin.getHost(), service, params)
      }
    },

    /**
     * Sends initial request
     */
    init: function () {
      this._request
        .on(YBRequest.Event.SUCCESS, this._receiveData.bind(this))
        .on(YBRequest.Event.ERROR, this._failedData.bind(this))
        .send()
    },

    _receiveData: function (req, e) {
      try {
        var msg = req.getXHR().response
        var resp = JSON.parse(msg.slice(msg.indexOf('(') + 1, msg.lastIndexOf(')')))

        this.response.host = Util.addProtocol(resp.q.h)
        this.response.code = resp.q.c
        this.response.pingTime = resp.q.pt

        this.done()
      } catch (err) {
        Log.error('Fastdata response is invalid.')
      }
    },

    _failedData: function (req, e) {
      Log.error('Fastdata request failed.')
    },

    /**
     * Call this method when a new content begins, it will increment the view index (_0, _1, _2...)
     * @return {string} new viewcode
     */
    nextView: function () {
      this._viewIndex += 1
      return this.getViewCode()
    },

    /**
     * Returns current viewcode
     * @return {string} viewcode
     */
    getViewCode: function () {
      return this.response.code + '_' + this._viewIndex
    },

    /**
     * Transform requests
     * @param {youbora.comm.YBRequest} request YBRequest to transform.
     */
    parse: function (request) {
      request.host = request.host || this.response.host
      request.params.code = request.params.code || this.getViewCode()
      if (request.service === Constants.Service.PING ||
        request.service === Constants.Service.START) {
        request.params.pingTime = request.params.pingTime || this.response.pingTime
      }
    }
  })

module.exports = ViewTransform


/***/ }),
/* 18 */
/***/ (function(module, exports, __webpack_require__) {

var YouboraObject = __webpack_require__(1)
var Log = __webpack_require__(0)

var Options = YouboraObject.extend(
  /** @lends Options.prototype */
  {
    /**
     * This Class store youbora configuration settings.
     * @constructs Options
     * @param {Object|Options} [options] A literal containing values.
     * @extends YouboraObject
     * @memberof youbora
     */
    constructor: function (options) {
      /** @prop {boolean} [enabled=true] If false, the plugin won't send NQS requests. */
      this['enabled'] = true

      /**
       * @prop {boolean} [httpSecure=null]
       * Define the security of NQS calls.
       * If true it will use 'https://',
       * if false it will use 'http://',
       * if null it will use '//'.
       */
      this['httpSecure'] = null

      /** @prop {string} [host='nqs.nice264.com'] Host of the Fastdata service. */
      this['host'] = 'nqs.nice264.com'

      /**
       * @prop {string} [accountCode='nicetest']
       * NicePeopleAtWork account code that indicates the customer account.
       */
      this['accountCode'] = 'nicetest'

      /** @prop {string} [username] User ID value inside your system. */
      this['username'] = null

      // PARSERS

      /**
       * @prop {boolean} [parse.Hls=false]
       * If true the plugin will parse HLS files to use the first .ts file found as resource.
       * It might slow performance down.
       */
      this['parse.Hls'] = false

      /**
       * @prop {string} [parse.CdnNameHeader]
       * If defined, resource parse will try to fetch the CDN code from the custom header defined
       * by this property. ie: 'x-cdn-forward'
       */
      this['parse.CdnNameHeader'] = 'x-cdn-forward'

      /**
       * @prop {boolean} [parse.CdnNode.enabled=false]
       * If true the plugin will query the CDN to retrieve the node name.
       * It might slow performance down.
       */
      this['parse.CdnNode'] = false

      /**
       * @prop {array<string>} [parse.CdnNode.list=false]
       * If true the plugin will query the CDN to retrieve the node name.
       * It might slow performance down.
       */
      this['parse.CdnNode.list'] = ['Akamai', 'Cloudfront', 'Level3', 'Fastly', 'Highwinds']

      // NETWORK

      /** @prop {string} [network.ip] IP of the viewer/user. ie= '100.100.100.100'. */
      this['network.ip'] = null

      /** @prop {string} [network.isp] Name of the internet service provider of the viewer/user. */
      this['network.isp'] = null

      /**
       * @prop {string} [network.connectionType]
       * See a list of codes in {@link http://mapi.youbora.com:8081/connectionTypes}
       */
      this['network.connectionType'] = null

      // DEVICE

      /**
       * @prop {string} [device.code]
       * Youbora's device code. If specified it will rewrite info gotten from user agent.
       * See a list of codes in {@link http://mapi.youbora.com:8081/devices}
       */
      this['device.code'] = null

      // CONTENT

      /** @prop {string} [content.transactionCode] Custom unique code to identify the view. */
      this['content.transactionCode'] = null

      /** @prop {string} [content.resource] URL/path of the current media resource. */
      this['content.resource'] = null

      /** @prop {boolean} [content.isLive] True if the content is live false if VOD. */
      this['content.isLive'] = null

      /** @prop {string} [content.title] Title of the media. */
      this['content.title'] = null

      /** @prop {string} [content.title2] Secondary title of the media. */
      this['content.title2'] = null

      /** @prop {number} [content.duration] Duration of the media. */
      this['content.duration'] = null

      /** @prop {int} {content.fps] Frames per second of the content in the current moment. */
      this['content.fps'] = null

      /** @prop {int} {content.bitrate] Bitrate of the content in bits per second. */
      this['content.bitrate'] = null

      /** @prop {int} {content.throughput] Throughput of the client bandwith in bits per second. */
      this['content.throughput'] = null

      /** @prop {string} {content.rendition] Name of the current rendition of the content. */
      this['content.rendition'] = null

      /**
       * @prop {string} [content.cdn]
       * Codename of the CDN where the content is streaming from.
       * See a list of codes in {@link http://mapi.youbora.com:8081/cdns}
       * */
      this['content.cdn'] = null

      /**
       * @prop {object} [content.metadata={}]
       * Item containing mixed extra information about the content like: director, parental rating,
       * device info or the audio channels.This object may store any serializable key:value info.
       */
      this['content.metadata'] = {}

      // ADS

      /**
       * @prop {object} [ad.metadata={}]
       * Item containing mixed extra information about ads like: campaign name or request url.
       * This object may store any serializable key:value info.
       */
      this['ad.metadata'] = {}

      // EXTRAPARAMS

      /** @prop {string} [extraparam.1] Custom parameter 1. */
      this['extraparam.1'] = null

      /** @prop {string} [extraparam.2] Custom parameter 2. */
      this['extraparam.2'] = null

      /** @prop {string} [extraparam.3] Custom parameter 3. */
      this['extraparam.3'] = null

      /** @prop {string} [extraparam.4] Custom parameter 4. */
      this['extraparam.4'] = null

      /** @prop {string} [extraparam.5] Custom parameter 5. */
      this['extraparam.5'] = null

      /** @prop {string} [extraparam.6] Custom parameter 6. */
      this['extraparam.6'] = null

      /** @prop {string} [extraparam.7] Custom parameter 7. */
      this['extraparam.7'] = null

      /** @prop {string} [extraparam.8] Custom parameter 8. */
      this['extraparam.8'] = null

      /** @prop {string} [extraparam.9] Custom parameter 9. */
      this['extraparam.9'] = null

      /** @prop {string} [extraparam.10] Custom parameter 10. */
      this['extraparam.10'] = null

      this.setOptions(options)
    },

    /**
     * Recursively sets the properties present in the params object.
     * ie: this.username = params.username.
     *
     * @param {Object} options A literal or another Data containing values.
     * @param {Object} [base=this] Start point for recursion.
     */
    setOptions: function (options, base) {
      try {
        base = base || this
        if (typeof options !== 'undefined') {
          for (var key in options) {
            if (typeof base[key] === 'object' && base[key] !== null) {
              this.setOptions(options[key], base[key])
            } else {
              base[key] = options[key]
            }
          }
        }
      } catch (err) {
        Log.error(err)
      }
    }
  }
)

module.exports = Options


/***/ }),
/* 19 */
/***/ (function(module, exports, __webpack_require__) {

var YouboraObject = __webpack_require__(1)
var Log = __webpack_require__(0)

var startParams = [
  'accountCode',
  'username',
  'rendition',
  'title',
  'title2',
  'live',
  'mediaDuration',
  'mediaResource',
  'transactionCode',
  'properties',
  'cdn',
  'playerVersion',
  'param1',
  'param2',
  'param3',
  'param4',
  'param5',
  'param6',
  'param7',
  'param8',
  'param9',
  'param10',
  'pluginVersion',
  'pluginInfo',
  'isp',
  'connectionType',
  'ip',
  'deviceCode',
  'preloadDuration'
]

var RequestBuilder = YouboraObject.extend(
  /** @lends RequestBuilder.prototype */
  {
    /**
     * This class helps building params associated with each event: /start, /joinTime...
     *
     * @constructs RequestBuilder
     * @extends YouboraObject
     * @memberof youbora
     *
     * @param {Plugin} plugin A Plugin instance
     */
    constructor: function (plugin) {
      this._plugin = plugin
      this._adNumber = 0

      /** Stores a list of the last params fetched */
      this.lastSent = {}
    },

    /**
     * Adds to params all the entities specified in paramList, unless they are already set.
     *
     * @param {Object} params Object of params key:value.
     * @param {Array[string]} paramList A list of params to fetch.
     * @param {bool} onlyDifferent If true, only fetches params that have changed
     */
    fetchParams: function (params, paramList, onlyDifferent) {
      params = params || {}
      paramList = paramList || []
      for (var i = 0; i < paramList.length; i++) {
        var param = paramList[i]

        if (params[param]) { continue }
        var getterName = RequestBuilder.getters[param]

        if (this._plugin[getterName]) {
          var value = this._plugin[getterName]()
          if (value !== null && (!onlyDifferent || this.lastSent[param] !== value)) {
            params[param] = value
            this.lastSent[param] = value
          }
        } else {
          Log.warn('Trying to call undefined getter ' + param + ':' + getterName)
        }
      }

      return params
    },

    /**
     * Adds to params object all the entities specified in paramList, unless they are already set.
     *
     * @param {Object} params Object of params key:value.
     * @param {string} service The name of the service. Use {@link Plugin.Service} enum.
     */
    buildParams: function (params, service) {
      params = params || {}
      this.fetchParams(params, RequestBuilder.params[service], false)
      this.fetchParams(params, RequestBuilder.differentParams[service], true)
      return params
    },

    /**
     * Creates an adnumber if it does not exist and stores it in lastSent. If it already exists,
     * it is incremented by 1.
     *
     * @returns {number} adNumber
     */
    getNewAdNumber: function () {
      var adNumber = this.lastSent.adNumber
      if (adNumber && this.lastSent.adPosition === this._plugin.getAdPosition()) {
        adNumber += 1
      } else {
        adNumber = 1
      }
      this.lastSent.adNumber = adNumber
      return adNumber
    },

    /**
     * Return changed entities since last check
     *
     * @returns {Object} params
     */
    getChangedEntities: function () {
      return this.fetchParams({}, RequestBuilder.differentParams['entities'], true)
    }
  },
  /* @lends RequestBuilder */
  {
    // Static Members

    /** List of params used by each service */
    params: {
      '/data': ['system', 'pluginVersion'],
      '/init': startParams,
      '/start': startParams,
      '/joinTime': ['joinDuration', 'playhead'],
      '/pause': ['playhead'],
      '/resume': ['pauseDuration', 'playhead'],
      '/seek': ['seekDuration', 'playhead'],
      '/bufferUnderrun': ['bufferDuration', 'playhead'],
      '/error': ['player'].concat(startParams),
      '/stop': ['bitrate', 'playhead'],
      '/adStart': [
        'playhead',
        'adTitle',
        'adPosition',
        'adDuration',
        'adResource',
        'adPlayerVersion',
        'adProperties',
        'adAdapterVersion'
      ],
      '/adJoin': ['adPosition', 'adJoinDuration', 'adPlayhead'],
      '/adPause': ['adPosition', 'adPlayhead'],
      '/adResume': ['adPosition', 'adPlayhead', 'adPauseDuration'],
      '/adBufferUnerrun': ['adPosition', 'adPlayhead', 'adBufferDuration'],
      '/adStop': ['adPosition', 'adPlayhead', 'adBitrate', 'adTotalDuration'],
      '/ping': ['droppedFrames', 'playrate']
    },

    /** List of params used by each service (only if they are different) */
    differentParams: {
      '/join': ['title', 'title2', 'live', 'mediaDuration', 'mediaResource'],
      '/adJoin': ['adTitle', 'adDuration', 'adResource'],
      'entities': [
        'rendition',
        'title',
        'title2',
        'live',
        'mediaDuration',
        'mediaResource',
        'param1',
        'param2',
        'param3',
        'param4',
        'param5',
        'param6',
        'param7',
        'param8',
        'param9',
        'param10',
        'connectionType',
        'deviceCode',
        'ip',
        'username',
        'cdn',
        'nodeHost',
        'nodeType',
        'nodeTypeString'
      ]
    },

    /** List of params and its related getter */
    getters: {
      playhead: 'getPlayhead',
      playrate: 'getPlayrate',
      fps: 'getFramesPerSecond',
      droppedFrames: 'getDroppedFrames',
      mediaDuration: 'getDuration',
      bitrate: 'getBitrate',
      throughput: 'getThroughput',
      rendition: 'getRendition',
      title: 'getTitle',
      title2: 'getTitle2',
      live: 'getIsLive',
      mediaResource: 'getResource',
      transactionCode: 'getTransactionCode',
      properties: 'getMetadata',
      playerVersion: 'getPlayerVersion',
      player: 'getPlayerName',
      cdn: 'getCdn',
      pluginVersion: 'getPluginVersion',

      param1: 'getExtraparam1',
      param2: 'getExtraparam2',
      param3: 'getExtraparam3',
      param4: 'getExtraparam4',
      param5: 'getExtraparam5',
      param6: 'getExtraparam6',
      param7: 'getExtraparam7',
      param8: 'getExtraparam8',
      param9: 'getExtraparam9',
      param10: 'getExtraparam10',

      adPosition: 'getAdPosition',
      adPlayhead: 'getAdPlayhead',
      adDuration: 'getAdDuration',
      adBitrate: 'getAdBitrate',
      adTitle: 'getAdTitle',
      adResource: 'getAdResource',
      adPlayerVersion: 'getAdPlayerVersion',
      adProperties: 'getAdMetadata',
      adAdapterVersion: 'getAdAdapterVersion',

      pluginInfo: 'getPluginInfo',

      isp: 'getIsp',
      connectionType: 'getConnectionType',
      ip: 'getIp',

      deviceCode: 'getDeviceCode',

      system: 'getAccountCode',
      accountCode: 'getAccountCode',
      username: 'getUsername',

      preloadDuration: 'getPreloadDuration',

      joinDuration: 'getJoinDuration',
      bufferDuration: 'getBufferDuration',
      seekDuration: 'getSeekDuration',
      pauseDuration: 'getPauseDuration',

      adJoinDuration: 'getAdJoinDuration',
      adBufferDuration: 'getAdBufferDuration',
      adPauseDuration: 'getAdPauseDuration',
      adTotalDuration: 'getAdTotalDuration',

      referer: 'getReferer',

      nodeHost: 'getNodeHost',
      nodeType: 'getNodeType',
      nodeTypeString: 'getNodeTypeString'
    }

  }
)

module.exports = RequestBuilder


/***/ }),
/* 20 */
/***/ (function(module, exports, __webpack_require__) {

var Emitter = __webpack_require__(2)
var Timer = __webpack_require__(8)
var Log = __webpack_require__(0)
var Util = __webpack_require__(7)
var Chrono = __webpack_require__(6)
var version = __webpack_require__(9)
var Constants = __webpack_require__(5)

var YBRequest = __webpack_require__(3)
var Communication = __webpack_require__(12)
var FlowTransform = __webpack_require__(25)
var ViewTransform = __webpack_require__(17)
var Nqs6Transform = __webpack_require__(13)
var ResourceTransform = __webpack_require__(14)

var Options = __webpack_require__(18)
var RequestBuilder = __webpack_require__(19)

var Adapter = __webpack_require__(10)

var Plugin = Emitter.extend(
  /** @lends Plugin.prototype */
  {
    /**
     * This is the main class of video analytics. You may want one instance for each video you want
     * to track. Will need adapters for both content and ads, manage options and general flow.
     *
     * @constructs Plugin
     * @extends Emitter
     * @memberof youbora
     *
     * @param {Options} [options] An object complying with {@link Options} constructor.
     * @param {Adapter} [adapter] If an adapter is provided, setAdapter will be immediately called.
     */
    constructor: function (options, adapter) {
      /** This flags indicates that /init has been called. */
      this.isInitiated = false

      /** This flags indicate that the content is preloading. */
      this.isPreloading = false

      /** Chrono for preload times. */
      this.preloadChrono = new Chrono()

      /** Chrono for init to join time. */
      this.initChrono = new Chrono()

      this.options = new Options(options)
      this._adapter = null
      this._adsAdapter = null
      this._ping = this._ping = new Timer(this._sendPing.bind(this), 5000)

      this.requestBuilder = new RequestBuilder(this)

      this.resourceTransform = new ResourceTransform(this)

      // FastData
      this.viewTransform = new ViewTransform(this)
      this.viewTransform.on(ViewTransform.Event.DONE, function (e) {
        this._ping.interval = e.target.response.pingTime * 1000
      }.bind(this))

      if (adapter) this.setAdapter(adapter)

      this.viewTransform.init()
    },

    /**
     * Reset all variables and stop all timers
     */
    _reset: function () {
      this._stopPings()
      this.resourceTransform = new ResourceTransform(this)

      this.isInitiated = false
      this.isPreloading = false
      this.initChrono.reset()
      this.preloadChrono.reset()
    },

    // ----------------------------------------- Options ------------------------------------------

    /**
     * Modifies current options. See {@link Options.setOptions}.
     *
     * @param {any} options
     */
    setOptions: function (options) {
      this.options.setOptions(options)
    },

    // ----------------------------------------- Adapters -----------------------------------------

    /**
     * Sets an adapter for video content.
     *
     * @param {Adapter} adapter
     */
    setAdapter: function (adapter) {
      if (adapter.plugin) {
        Log.warn('Adapters can only be added to a single plugin')
      } else {
        this.removeAdapter()

        this._adapter = adapter
        adapter.plugin = this

        // Register listeners
        adapter.on(Adapter.Event.START, this._startListener.bind(this))
        adapter.on(Adapter.Event.JOIN, this._joinListener.bind(this))
        adapter.on(Adapter.Event.PAUSE, this._pauseListener.bind(this))
        adapter.on(Adapter.Event.RESUME, this._resumeListener.bind(this))
        adapter.on(Adapter.Event.SEEK_BEGIN, this._seekBeginListener.bind(this))
        adapter.on(Adapter.Event.SEEK_END, this._seekEndListener.bind(this))
        adapter.on(Adapter.Event.BUFFER_BEGIN, this._bufferBeginListener.bind(this))
        adapter.on(Adapter.Event.BUFFER_END, this._bufferEndListener.bind(this))
        adapter.on(Adapter.Event.ERROR, this._errorListener.bind(this))
        adapter.on(Adapter.Event.STOP, this._stopListener.bind(this))
      }
    },

    /**
     * Returns current adapter or null.
     *
     * @returns {Adapter}
     */
    getAdapter: function () {
      return this._adapter
    },

    /** Removes the current adapter. Fires stop if needed. Calls adapter.dispose() */
    removeAdapter: function () {
      if (this._adapter) {
        this._adapter.dispose()

        this._adapter.plugin = null

        this._adapter.off(Adapter.Event.START, this._startListener)
        this._adapter.off(Adapter.Event.JOIN, this._joinListener)
        this._adapter.off(Adapter.Event.PAUSE, this._pauseListener)
        this._adapter.off(Adapter.Event.RESUME, this._resumeListener)
        this._adapter.off(Adapter.Event.SEEK_BEGIN, this._seekBeginListener)
        this._adapter.off(Adapter.Event.SEEK_END, this._seekEndListener)
        this._adapter.off(Adapter.Event.BUFFER_BEGIN, this._bufferBeginListener)
        this._adapter.off(Adapter.Event.BUFFER_END, this._bufferEndListener)
        this._adapter.off(Adapter.Event.ERROR, this._errorListener)
        this._adapter.off(Adapter.Event.STOP, this._stopListener)

        this._adapter = null
      }
    },

    /**
     * Sets an adapter for ads.
     *
     * @param {Adapter} adsAdapter
     */
    setAdsAdapter: function (adsAdapter) {
      if (adsAdapter.plugin) {
        Log.warn('Adapters can only be added to a single plugin')
      } else {
        this.removeAdsAdapter()

        adsAdapter.plugin = this
        this._adsAdapter = adsAdapter

        adsAdapter.on(Adapter.Event.START, this._adStartListener.bind(this))
        adsAdapter.on(Adapter.Event.JOIN, this._adJoinListener.bind(this))
        adsAdapter.on(Adapter.Event.PAUSE, this._adPauseListener.bind(this))
        adsAdapter.on(Adapter.Event.RESUME, this._adResumeListener.bind(this))
        adsAdapter.on(Adapter.Event.BUFFER_BEGIN, this._adBufferBeginListener.bind(this))
        adsAdapter.on(Adapter.Event.BUFFER_END, this._adBufferEndListener.bind(this))
        adsAdapter.on(Adapter.Event.STOP, this._adStopListener.bind(this))
      }
    },

    /**
     * Returns current adapter or null.
     *
     * @returns {Adapter}
     */
    getAdsAdapter: function () {
      return this._adsAdapter
    },

    /** Removes the current adapter. Fires stop if needed. Calls adapter.dispose() */
    removeAdsAdapter: function () {
      if (this._adsAdapter) {
        this._adsAdapter.dispose()

        this._adsAdapter.plugin = null

        this._adsAdapter.off(Adapter.Event.START, this._adStartListener)
        this._adsAdapter.off(Adapter.Event.JOIN, this._adJoinListener)
        this._adsAdapter.off(Adapter.Event.PAUSE, this._adPauseListener)
        this._adsAdapter.off(Adapter.Event.RESUME, this._adResumeListener)
        this._adsAdapter.off(Adapter.Event.BUFFER_BEGIN, this._adBufferBeginListener)
        this._adsAdapter.off(Adapter.Event.BUFFER_END, this._adBufferEndListener)
        this._adsAdapter.off(Adapter.Event.STOP, this._adStopListener)

        this._adsAdapter = null
      }
    },

    // ----------------------------------------- DISABLE ------------------------------------------

    /**
     * Disable request sending.
     */
    disable: function () {
      this.setOptions({ 'enabled': false })
    },

    /**
     * Re-enable request sending.
     */
    enable: function () {
      this.setOptions({ 'enabled': true })
    },

    // ---------------------------------------- LISTENERS -----------------------------------------

    /**
     * Creates and enqueues related request using {@link Communication#sendRequest}.
     * It will fire will-send-events.
     *
     * @param {string} willSendEvent Name of the will-send event. Use {@link Plugin.Event} enum.
     * @param {string} service Name of the service. Use {@link Constants.Service} enum.
     * @param {Object} params Params of the request
     */
    _send: function (willSendEvent, service, params) {
      params = this.requestBuilder.buildParams(params, service)

      var data = {
        params: params,
        plugin: this,
        adapter: this.getAdapter(),
        adsAdapter: this.getAdsAdapter()
      }

      this.emit(willSendEvent, data)

      if (this._comm && params !== null && this.options.enabled) {
        this.lastServeiceSent = service
        this._comm.sendRequest(new YBRequest(null, service, params))
      }
    },

    /**
     * Initializes comm and its transforms.
     */
    _initComm: function () {
      this.resourceTransform.init(this.getResource())

      this._comm = new Communication()
      this._comm.addTransform(new FlowTransform())
      this._comm.addTransform(this.viewTransform)
      this._comm.addTransform(this.resourceTransform)
      this._comm.addTransform(new Nqs6Transform())
    },

    /**
     * Starts preloading state and chronos.
     */
    firePreloadBegin: function () {
      if (!this.isPreloading) {
        this.isPreloading = true
        this.preloadChrono.start()
      }
    },

    /**
     * Ends preloading state and chronos.
     */
    firePreloadEnd: function () {
      if (this.isPreloading) {
        this.isPreloading = false
        this.preloadChrono.stop()
      }
    },

    /**
     * Sends /init. Should be called once the user has requested the content. Does not need
     * a working adapter or player to work. it won't sent start if isInitiated is true.
     *
     * @param {Object} [params] Object of key:value params.
     */
    fireInit: function (params) {
      if (!this.isInitiated) {
        this.viewTransform.nextView()
        this._initComm()
        this._startPings()

        this.isInitiated = true
        this.initChrono.start()

        params = params || {}
        this._send(Plugin.Event.WILL_SEND_INIT, Constants.Service.INIT, params)
        Log.notice(Constants.Service.INIT + ' ' + (params.title || params.mediaResource))
      }
    },

    /**
     * Sends /error. Should be used when the error is related to out-of-player errors: like async
     * resource load or player loading errors.
     *
     * @param {String|Object} [code] Error Code, if an object is sent, it will be treated as params.
     * @param {String} [msg] Error Message
     * @param {Object} [metadata] Object defining error metadata
     * @param {String} [level] Level of the error. Currently supports 'error' and 'fatal'
     */
    fireError: function (object, msg, metadata, level) {
      if (!this._comm) this._initComm()

      var params = Util.buildErrorParams(object, msg, metadata, level)

      this._send(Plugin.Event.WILL_SEND_ERROR, Constants.Service.ERROR, params)
      Log.notice(Constants.Service.ERROR +
        ' ' + params.errorLevel +
        ' ' + params.errorCode
      )

      if (params.errorLevel === 'fatal') this._reset()
    },

    /**
     * Fires /stop. Should be used to terminate sessions once the player is gone or if
     * plugin.fireError() is called.
     *
     * @param {Object} [params] Object of key:value params.
     */
    fireStop: function (params) {
      params = params || {}
      this._send(Plugin.Event.WILL_SEND_STOP, Constants.Service.STOP, params)

      Log.notice(Constants.Service.STOP + ' at ' + params.playhead + 's')

      this._reset()
    },

    _startListener: function (e) {
      if (!this.isInitiated || this.lastServeiceSent === Constants.Service.ERROR) {
        this.viewTransform.nextView()
        this._initComm()
        this._startPings()
      }

      var params = e.data.params || {}
      this._send(Plugin.Event.WILL_SEND_START, Constants.Service.START, params)
      Log.notice(Constants.Service.START + ' ' + (params.title || params.mediaResource))
    },

    _joinListener: function (e) {
      var params = e.data.params || {}
      if (!this._adsAdapter || !this._adsAdapter.flags.isStarted) {
        this._send(Plugin.Event.WILL_SEND_JOIN, Constants.Service.JOIN, params)
        Log.notice(Constants.Service.JOIN + ' ' + params.joinDuration + 'ms')
      } else { // If it is currently showing ads, join is invalidated
        if (this._adapter.monitor) this._adapter.monitor.stop()
        this._adapter.flags.isJoined = false
        this._adapter.chronos.join.stopTime = 0
      }
    },

    _pauseListener: function (e) {
      if (this._adapter) {
        if (this._adapter.flags.isBuffering ||
          this._adapter.flags.isSeeking ||
          (this._adsAdapter && this._adsAdapter.flags.isStarted)) {
          this._adapter.chronos.pause.reset()
        }
      }

      var params = e.data.params || {}
      this._send(Plugin.Event.WILL_SEND_PAUSE, Constants.Service.PAUSE, params)
      Log.notice(Constants.Service.PAUSE + ' at ' + params.playhead + 's')
    },

    _resumeListener: function (e) {
      var params = e.data.params || {}
      this._send(Plugin.Event.WILL_SEND_RESUME, Constants.Service.RESUME, params)
      Log.notice(Constants.Service.RESUME + ' ' + params.pauseDuration + 'ms')
    },

    _seekBeginListener: function (e) {
      if (this._adapter && this._adapter.flags.isPaused) this._adapter.chronos.pause.reset()
      Log.notice('Seek Begin')
    },

    _seekEndListener: function (e) {
      var params = e.data.params || {}
      this._send(Plugin.Event.WILL_SEND_SEEK, Constants.Service.SEEK, params)
      Log.notice(Constants.Service.SEEK +
        ' to ' + params.playhead +
        ' in ' + params.seekDuration + 'ms'
      )
    },

    _bufferBeginListener: function (e) {
      if (this._adapter && this._adapter.flags.isPaused) this._adapter.chronos.pause.reset()
      Log.notice('Buffer Begin')
    },

    _bufferEndListener: function (e) {
      var params = e.data.params || {}
      this._send(Plugin.Event.WILL_SEND_BUFFER, Constants.Service.BUFFER, params)
      Log.notice(Constants.Service.BUFFER +
        ' to ' + params.playhead +
        ' in ' + params.bufferDuration + 'ms'
      )
    },

    _errorListener: function (e) {
      this.fireError(e.data.params || {})
    },

    _stopListener: function (e) {
      this.fireStop(e.data.params || {})
    },

    // Ads
    _adStartListener: function (e) {
      if (this._adapter) {
        this._adapter.fireBufferEnd()
        this._adapter.fireSeekEnd()
        if (this._adapter.flags.isPaused) this._adapter.chronos.pause.reset()
      }

      var params = e.data.params || {}
      params.adNumber = this.requestBuilder.getNewAdNumber()
      this._send(Plugin.Event.WILL_SEND_AD_START, Constants.Service.AD_START, params)
      Log.notice(
        Constants.Service.AD_START + ' ' +
        params.adPosition + params.adNumber +
        ' at ' + params.playhead + 's'
      )
    },

    _adJoinListener: function (e) {
      var params = e.data.params || {}
      params.adNumber = this.requestBuilder.lastSent.adNumber
      this._send(Plugin.Event.WILL_SEND_AD_JOIN, Constants.Service.AD_JOIN, params)
      Log.notice(Constants.Service.AD_JOIN + ' ' + params.adJoinDuration + 'ms')
    },

    _adPauseListener: function (e) {
      var params = e.data.params || {}
      params.adNumber = this.requestBuilder.lastSent.adNumber
      this._send(Plugin.Event.WILL_SEND_AD_PAUSE, Constants.Service.AD_PAUSE, params)
      Log.notice(Constants.Service.AD_PAUSE + ' at ' + params.adPlayhead + 's')
    },

    _adResumeListener: function (e) {
      var params = e.data.params || {}
      params.adNumber = this.requestBuilder.lastSent.adNumber
      this._send(Plugin.Event.WILL_SEND_AD_RESUME, Constants.Service.AD_RESUME, params)
      Log.notice(Constants.Service.AD_RESUME + ' ' + params.adPauseDuration + 'ms')
    },

    _adBufferBeginListener: function (e) {
      Log.notice('Ad Buffer Begin')
      if (this._adsAdapter && this._adsAdapter.flags.isPaused) {
        this._adsAdapter.chronos.pause.reset()
      }
    },

    _adBufferEndListener: function (e) {
      var params = e.data.params || {}
      params.adNumber = this.requestBuilder.lastSent.adNumber
      this._send(Plugin.Event.WILL_SEND_AD_BUFFER, Constants.Service.AD_BUFFER, params)
      Log.notice(Constants.Service.AD_BUFFER + ' ' + params.adBufferDuration + 'ms')
    },

    _adStopListener: function (e) {
      // remove time from joinDuration
      if (this._adapter && !this._adapter.flags.isJoined) {
        this._adapter.chronos.join.startTime = Math.min(
          this._adapter.chronos.join.startTime + this._adsAdapter.chronos.total.getDeltaTime(),
          new Date().getTime()
        )
      }

      var params = e.data.params || {}
      params.adNumber = this.requestBuilder.lastSent.adNumber
      this._send(Plugin.Event.WILL_SEND_AD_STOP, Constants.Service.AD_STOP, params)
      Log.notice(Constants.Service.AD_STOP + ' ' + params.adTotalDuration + 'ms')
    },

    // ------------------------------------------ PINGS -------------------------------------------

    /**
     * Starts sending pings
     * @private
     */
    _startPings: function () {
      if (!this._ping.isRunning) this._ping.start()
    },

    /**
     * Stops sending pings
     * @private
     */
    _stopPings: function () {
      this._ping.stop()
    },

    _sendPing: function (diffTime) {
      var params = {
        diffTime: diffTime,
        entities: this.requestBuilder.getChangedEntities()
      }
      if (this._adapter) {
        if (this._adapter.flags.isPaused) {
          params = this.requestBuilder.fetchParams(params, ['pauseDuration'])
        } else {
          params = this.requestBuilder.fetchParams(params, ['bitrate', 'throughput', 'fps'])

          if (this._adsAdapter && this._adsAdapter.flags.isStarted) {
            params = this.requestBuilder.fetchParams(params, ['adBitrate'])
          }
        }
        if (this._adapter.flags.isJoined) {
          params = this.requestBuilder.fetchParams(params, ['playhead'])
        }
        if (this._adapter.flags.isBuffering) {
          params = this.requestBuilder.fetchParams(params, ['bufferDuration'])
        }
        if (this._adapter.flags.isSeeking) {
          params = this.requestBuilder.fetchParams(params, ['seekDuration'])
        }

        if (this._adsAdapter) {
          if (this._adsAdapter.flags.isStarted) {
            params = this.requestBuilder.fetchParams(params, ['adPlayhead'])
          }
          if (this._adsAdapter.flags.isBuffering) {
            params = this.requestBuilder.fetchParams(params, ['adBufferDuration'])
          }
        }
      }

      this._send(Plugin.Event.WILL_SEND_PING, Constants.Service.PING, params)
      Log.verbose(Constants.Service.PING)
    },

    // --------------------------------------- INFO GETTERS ---------------------------------------

    /** Returns service host */
    getHost: function () {
      return Util.addProtocol(
        Util.stripProtocol(this.options['host']),
        this.options['httpSecure'])
    },

    /** Returns parse HLS Flag */
    isParseHls: function () {
      return this.options['parse.Hls']
    },

    /** Returns parse CdnNode Flag */
    isParseCdnNode: function () {
      return this.options['parse.CdnNode']
    },

    /** Returns Cdn list */
    getParseCdnNodeList: function () {
      return this.options['parse.CdnNode.list']
    },

    /** Returns Cdn header name */
    getParseCdnNodeNameHeader: function () {
      return this.options['parse.CdnNameHeader']
    },

    /** Returns content's playhead */
    getPlayhead: function () {
      var ret = 0
      if (this._adapter) {
        try {
          ret = this._adapter.getPlayhead()
        } catch (err) {
          Log.warn('An error occurred while calling getPlayhead', err)
        }
      }
      return Util.parseNumber(ret, 0)
    },

    /** Returns content's PlayRate */
    getPlayrate: function () {
      var ret = 0
      if (this._adapter) {
        try {
          ret = this._adapter.getPlayrate()
        } catch (err) {
          Log.warn('An error occured while calling getPlayrate', err)
        }
      }
      return ret
    },

    /** Returns content's FramesPerSecond */
    getFramesPerSecond: function () {
      var ret = null
      if (this._adapter) {
        try {
          ret = this._adapter.getFramesPerSecond()
        } catch (err) {
          Log.warn('An error occured while calling getFramesPerSecond', err)
        }
      }
      return ret
    },

    /** Returns content's DroppedFrames */
    getDroppedFrames: function () {
      var ret = null
      if (this._adapter) {
        try {
          ret = this._adapter.getDroppedFrames()
        } catch (err) {
          Log.warn('An error occured while calling getDroppedFrames', err)
        }
      }
      if (!ret) {
        ret = this.getWebkitDroppedFrames()
      }
      return Util.parseNumber(ret, 0)
    },

    /**
     * Returns dropped frames as per webkitDroppedFrameCount
     *
     * @returns {number}
     */
    getWebkitDroppedFrames: function () {
      if (this._adapter && this._adapter.tag && this._adapter.tag.webkitDroppedFrameCount) {
        return this._adapter.tag.webkitDroppedFrameCount
      }
      return null
    },

    /** Returns content's Duration */
    getDuration: function () {
      var ret = this.options['content.duration']
      if (ret === null && this._adapter) {
        try {
          ret = this._adapter.getDuration()
        } catch (err) {
          Log.warn('An error occured while calling getDuration', err)
        }
      }
      return Util.parseNumber(Math.round(ret), 0)
    },

    /** Returns content's Bitrate */
    getBitrate: function () {
      var ret = this.options['content.bitrate']
      if (ret === null && this._adapter) {
        try {
          ret = this._adapter.getBitrate()
        } catch (err) {
          Log.warn('An error occured while calling getBitrate', err)
        }

        if (!ret || ret === -1) {
          ret = this.getWebkitBitrate()
        }
      }
      return Util.parseNumber(ret, -1)
    },

    /**
     * Returns bitrate as per webkitVideoDecodedByteCount
     *
     * @param {Object} tag Video tag DOM reference.
     * @returns {number}
     */
    getWebkitBitrate: function () {
      if (this._adapter && this._adapter.tag && this._adapter.tag.webkitVideoDecodedByteCount) {
        var bitrate = this._adapter.tag.webkitVideoDecodedByteCount
        if (this._lastWebkitBitrate) {
          var delta = this._adapter.tag.webkitVideoDecodedByteCount - this._lastWebkitBitrate
          bitrate = Math.round(((delta) / this.viewTransform.response.pingTime) * 8)
        }
        this._lastWebkitBitrate = this._adapter.tag.webkitVideoDecodedByteCount
        return bitrate !== 0 ? bitrate : -1
      }
    },

    /** Returns content's Throughput */
    getThroughput: function () {
      var ret = this.options['content.throughput']
      if (ret === null && this._adapter) {
        try {
          ret = this._adapter.getThroughput()
        } catch (err) {
          Log.warn('An error occured while calling getThroughput', err)
        }
      }
      return Util.parseNumber(ret, -1)
    },

    /** Returns content's Rendition */
    getRendition: function () {
      var ret = this.options['content.rendition']
      if (ret === null && this._adapter) {
        try {
          ret = this._adapter.getRendition()
        } catch (err) {
          Log.warn('An error occured while calling getRendition', err)
        }
      }
      return ret
    },

    /** Returns content's Title */
    getTitle: function () {
      var ret = this.options['content.title']
      if (ret === null && this._adapter) {
        try {
          ret = this._adapter.getTitle()
        } catch (err) {
          Log.warn('An error occured while calling getTitle', err)
        }
      }
      return ret
    },

    /** Returns content's Title2 */
    getTitle2: function () {
      var ret = this.options['content.title2']
      if (ret === null && this._adapter) {
        try {
          ret = this._adapter.getTitle2()
        } catch (err) {
          Log.warn('An error occured while calling getTitle2', err)
        }
      }
      return ret
    },

    /** Returns content's IsLive */
    getIsLive: function () {
      var ret = this.options['content.isLive']
      if (ret === null && this._adapter) {
        try {
          ret = this._adapter.getIsLive()
        } catch (err) {
          Log.warn('An error occured while calling getIsLive', err)
        }
      }
      return ret || false
    },

    /** Returns content's Resource after being parsed by the resourceTransform */
    getResource: function () {
      var ret = null
      if (!this.resourceTransform.isBlocking()) {
        ret = this.resourceTransform.getResource()
      }

      return ret || this.getOriginalResource()
    },

    /** Returns content's original Resource */
    getOriginalResource: function () {
      var ret = null
      ret = this.options['content.resource']
      if (ret === null && this._adapter) {
        try {
          ret = this._adapter.getResource()
        } catch (err) {
          Log.warn('An error occured while calling getResource', err)
          ret = null
        }
      }
      return ret || 'unknown'
    },

    /** Returns content's TransactionCode */
    getTransactionCode: function () {
      return this.options['content.transactionCode']
    },

    /** Returns content's Metadata */
    getMetadata: function () {
      return this.options['content.metadata']
    },

    /** Returns content's PlayerVersion */
    getPlayerVersion: function () {
      var ret = ''
      if (this._adapter) {
        try {
          ret = this._adapter.getPlayerVersion()
        } catch (err) {
          Log.warn('An error occured while calling getPlayerVersion', err)
        }
      }
      return ret
    },

    /** Returns content's PlayerName */
    getPlayerName: function () {
      var ret = ''
      if (this._adapter) {
        try {
          ret = this._adapter.getPlayerName()
        } catch (err) {
          Log.warn('An error occured while calling getPlayerName', err)
        }
      }
      return ret
    },

    /** Returns content's Cdn */
    getCdn: function () {
      var ret = null
      if (!this.resourceTransform.isBlocking()) {
        ret = this.resourceTransform.getCdnName()
      }
      return ret || this.options['content.cdn']
    },

    /** Returns content's PluginVersion */
    getPluginVersion: function () {
      var ret = this.getAdapterVersion()
      if (!ret) ret = version + '-adapterless'

      return ret
    },

    /** Returns ads adapter getVersion or null */
    getAdapterVersion: function () {
      var ret = null
      if (this._adapter) {
        try {
          ret = this._adapter.getVersion()
        } catch (err) {
          Log.warn('An error occured while calling getPluginVersion', err)
        }
      }
      return ret
    },

    /** Returns content's Extraparam1 */
    getExtraparam1: function () {
      return this.options['extraparam.1']
    },

    /** Returns content's Extraparam2 */
    getExtraparam2: function () {
      return this.options['extraparam.2']
    },

    /** Returns content's Extraparam3 */
    getExtraparam3: function () {
      return this.options['extraparam.3']
    },

    /** Returns content's Extraparam4 */
    getExtraparam4: function () {
      return this.options['extraparam.4']
    },
    /** Returns content's Extraparam5 */
    getExtraparam5: function () {
      return this.options['extraparam.5']
    },

    /** Returns content's Extraparam6 */
    getExtraparam6: function () {
      return this.options['extraparam.6']
    },

    /** Returns content's Extraparam7 */
    getExtraparam7: function () {
      return this.options['extraparam.7']
    },

    /** Returns content's Extraparam8 */
    getExtraparam8: function () {
      return this.options['extraparam.8']
    },

    /** Returns content's Extraparam9 */
    getExtraparam9: function () {
      return this.options['extraparam.9']
    },

    /** Returns content's Extraparam10 */
    getExtraparam10: function () {
      return this.options['extraparam.10']
    },

    /** Returns ads's PlayerVersion */
    getAdPlayerVersion: function () {
      var ret = ''
      if (this._adsAdapter) {
        try {
          ret = this._adsAdapter.getPlayerVersion()
        } catch (err) {
          Log.warn('An error occured while calling getAdPlayerVersion', err)
        }
      }
      return ret
    },

    /** Returns ad's position */
    getAdPosition: function () {
      var ret = 'pre'
      if (this._adsAdapter) {
        try {
          ret = this._adsAdapter.getPosition()
        } catch (err) {
          Log.warn('An error occured while calling getAdPosition', err)
        }
      }
      if (!ret && this._adapter) {
        ret = (this._adapter.flags.isJoined) ? 'mid' : 'pre'
      }
      return ret
    },

    /** Returns ad's AdPlayhead */
    getAdPlayhead: function () {
      var ret = null
      if (this._adsAdapter) {
        try {
          ret = this._adsAdapter.getPlayhead()
        } catch (err) {
          Log.warn('An error occured while calling getAdPlayhead', err)
        }
      }
      return Util.parseNumber(ret, 0)
    },

    /** Returns ad's AdDuration */
    getAdDuration: function () {
      var ret = null
      if (this._adsAdapter) {
        try {
          ret = this._adsAdapter.getDuration()
        } catch (err) {
          Log.warn('An error occured while calling getAdDuration', err)
        }
      }
      return Util.parseNumber(ret, 0)
    },

    /** Returns ad's AdBitrate */
    getAdBitrate: function () {
      var ret = null
      if (this._adsAdapter) {
        try {
          ret = this._adsAdapter.getBitrate()
        } catch (err) {
          Log.warn('An error occured while calling getAdBitrate', err)
        }

        if (!ret || ret === -1) {
          ret = this.getWebkitAdBitrate()
        }
      }
      return Util.parseNumber(ret, -1)
    },

    /**
     * Returns bitrate as per webkitVideoDecodedByteCount
     *
     * @param {Object} tag Video tag DOM reference.
     * @returns {number}
     */
    getWebkitAdBitrate: function () {
      if (this._adapter && this._adapter.tag && this._adapter.tag.webkitVideoDecodedByteCount) {
        var bitrate = this._adapter.tag.webkitVideoDecodedByteCount
        if (this._lastWebkitAdBitrate) {
          var delta = this._adapter.tag.webkitVideoDecodedByteCount - this._lastWebkitAdBitrate
          bitrate = Math.round(((delta) / this.viewTransform.response.pingTime) * 8)
        }
        this._lastWebkitAdBitrate = this._adapter.tag.webkitVideoDecodedByteCount
        return bitrate !== 0 ? bitrate : -1
      }
    },

    /** Returns ad's AdTitle */
    getAdTitle: function () {
      var ret = null
      if (this._adsAdapter) {
        try {
          ret = this._adsAdapter.getTitle()
        } catch (err) {
          Log.warn('An error occured while calling getAdTitle', err)
        }
      }
      return ret
    },

    /** Returns ad's AdResource */
    getAdResource: function () {
      var ret = null
      if (this._adsAdapter) {
        try {
          ret = this._adsAdapter.getResource()
        } catch (err) {
          Log.warn('An error occured while calling getAdResource', err)
        }
      }
      return ret
    },

    /** Returns ads adapter getVersion or null */
    getAdAdapterVersion: function () {
      var ret = null
      if (this._adsAdapter) {
        try {
          ret = this._adsAdapter.getVersion()
        } catch (err) {
          Log.warn('An error occured while calling getAdsAdapterVersion', err)
        }
      }
      return ret
    },

    /** Returns ad's AdMetadata */
    getAdMetadata: function () {
      return this.options['ad.metadata']
    },

    /** Returns PluginInfo */
    getPluginInfo: function () {
      var ret = {
        lib: version,
        adapter: this.getAdapterVersion(),
        adAdapter: this.getAdAdapterVersion()
      }
      return ret
    },

    /** Returns Ip */
    getIp: function () {
      return this.options['network.ip']
    },

    /** Returns Isp */
    getIsp: function () {
      return this.options['network.isp']
    },

    /** Returns ConnectionType */
    getConnectionType: function () {
      return this.options['network.connectionType']
    },

    /** Returns DeviceCode */
    getDeviceCode: function () {
      return this.options['device.code']
    },

    /** Returns AccountCode */
    getAccountCode: function () {
      return this.options['accountCode']
    },

    /** Returns Username */
    getUsername: function () {
      return this.options['username']
    },

    /** Get URL referer. */
    getReferer: function () {
      var ret = ''
      if (typeof window !== 'undefined' && window.location) {
        ret = window.location.href
      }
      return ret
    },

    /**
     * Returns the nodehost
     */
    getNodeHost: function () {
      return this.resourceTransform.getNodeHost()
    },

    /**
     * Returns the node type id
     */
    getNodeType: function () {
      return this.resourceTransform.getNodeType()
    },

    /**
     * Returns the node type string
     */
    getNodeTypeString: function () {
      return this.resourceTransform.getNodeTypeString()
    },

    // ----------------------------------------- CHRONOS ------------------------------------------

    /** Returns preload chrono delta time */
    getPreloadDuration: function () {
      return this.preloadChrono.getDeltaTime(false)
    },

    getInitDuration: function () {
      return this.initChrono.getDeltaTime(false)
    },

    /** Returns JoinDuration chrono delta time */
    getJoinDuration: function () {
      if (this.isInitiated) return this.getInitDuration()
      return this._adapter ? this._adapter.chronos.join.getDeltaTime(false) : -1
    },

    /** Returns BufferDuration chrono delta time */
    getBufferDuration: function () {
      return this._adapter ? this._adapter.chronos.buffer.getDeltaTime(false) : -1
    },

    /** Returns SeekDuration chrono delta time */
    getSeekDuration: function () {
      return this._adapter ? this._adapter.chronos.seek.getDeltaTime(false) : -1
    },

    /** Returns pauseDuration chrono delta time */
    getPauseDuration: function () {
      return this._adapter ? this._adapter.chronos.pause.getDeltaTime(false) : -1
    },

    /** Returns AdJoinDuration chrono delta time */
    getAdJoinDuration: function () {
      return this._adsAdapter ? this._adsAdapter.chronos.join.getDeltaTime(false) : -1
    },

    /** Returns AdBufferDuration chrono delta time */
    getAdBufferDuration: function () {
      return this._adsAdapter ? this._adsAdapter.chronos.buffer.getDeltaTime(false) : -1
    },

    /** Returns AdPauseDuration chrono delta time */
    getAdPauseDuration: function () {
      return this._adsAdapter ? this._adsAdapter.chronos.pause.getDeltaTime(false) : -1
    },

    /** Returns total totalAdDuration chrono delta time */
    getAdTotalDuration: function () {
      return this._adsAdapter ? this._adsAdapter.chronos.total.getDeltaTime(false) : -1
    }
  },

  /** @lend Plugin */
  {
    // Static Memebers //
    /**
     * List of events that could be fired
     * @enum
     */
    Event: {
      WILL_SEND_START: 'will-send-start',
      WILL_SEND_JOIN: 'will-send-join',
      WILL_SEND_PAUSE: 'will-send-pause',
      WILL_SEND_RESUME: 'will-send-resume',
      WILL_SEND_SEEK: 'will-send-seek',
      WILL_SEND_BUFFER: 'will-send-buffer',
      WILL_SEND_ERROR: 'will-send-error',
      WILL_SEND_FATAL_ERROR: 'will-send-fatal-error',
      WILL_SEND_STOP: 'will-send-stop',
      WILL_SEND_PING: 'will-send-ping',
      WILL_SEND_AD_START: 'will-send-ad-start',
      WILL_SEND_AD_JOIN: 'will-send-ad-join',
      WILL_SEND_AD_PAUSE: 'will-send-ad-pause',
      WILL_SEND_AD_RESUME: 'will-send-ad-resume',
      WILL_SEND_AD_BUFFER: 'will-send-ad-buffer',
      WILL_SEND_AD_STOP: 'will-send-ad-stop'
    }
  }
)

module.exports = Plugin


/***/ }),
/* 21 */
/***/ (function(module, exports) {

/* eslint no-extend-native: "off" */

/**
 * When executed, this function applies polyfills to the following functionalities:
 * Function.prototype.bind,
 * Object.assign,
 * Object.create,
 * Array.prototype.forEach,
 * Array.isArray
 *
 * @memberof youbora
 */
var applyPolyfills = function () {
  // Bind
  Function.prototype.bind = Function.prototype.bind || function (b) {
    if (typeof this !== 'function') {
      throw new TypeError('Function.prototype.bind - what is trying to be bound is not callable')
    }
    var a = Array.prototype.slice
    var f = a.call(arguments, 1)
    var e = this
    var C = function () {}
    var d = function () {
      return e.apply(this instanceof C ? this : b || window, f.concat(a.call(arguments)))
    }
    C.prototype = this.prototype
    d.prototype = new C()
    return d
  }

  // Assign
  Object.assign = Object.assign || function (target) {
    if (target === undefined || target === null) {
      throw new TypeError('Cannot convert undefined or null to object')
    }

    var output = Object(target)
    for (var index = 1; index < arguments.length; index++) {
      var source = arguments[index]
      if (source !== undefined && source !== null) {
        for (var nextKey in source) {
          if (source.hasOwnProperty(nextKey)) {
            output[nextKey] = source[nextKey]
          }
        }
      }
    }
    return output
  }

  // Create
  Object.create = Object.create || (function () {
    var Temp = function () {}
    return function (prototype, propertiesObject) {
      if (prototype !== Object(prototype) && prototype !== null) {
        throw TypeError('Argument must be an object, or null')
      }
      Temp.prototype = prototype || {}
      var result = new Temp()
      Temp.prototype = null
      if (propertiesObject !== undefined) {
        Object.defineProperties(result, propertiesObject)
      }

      // to imitate the case of Object.create(null)
      if (prototype === null) {
        result.prototype = null
      }
      return result
    }
  })()

  // Foreach
  Array.prototype.forEach = Array.prototype.forEach || function (callback, thisArg) {
    if (typeof (callback) !== 'function') {
      throw new TypeError(callback + ' is not a function!')
    }
    var len = this.length
    for (var i = 0; i < len; i++) {
      callback.call(thisArg, this[i], i, this)
    }
  }

  // isArray
  Array.isArray = Array.isArray || function (obj) {
    return Object.prototype.toString.call(obj) === '[object Array]'
  }
}

module.exports = applyPolyfills


/***/ }),
/* 22 */
/***/ (function(module, exports) {

module.exports = {
	"name": "youboralib",
	"type": "lib",
	"tech": "js",
	"author": "Jordi Aguilar",
	"version": "6.0.0-rc",
	"built": "2017-03-13",
	"repo": "https://bitbucket.org/npaw/lib-plugin-js.git"
};

/***/ }),
/* 23 */
/***/ (function(module, exports, __webpack_require__) {

var YouboraObject = __webpack_require__(1)
var Chrono = __webpack_require__(6)

var PlaybackChronos = YouboraObject.extend(
  /** @lends PlaybackChronos.prototype */
  {
    /**
     * This class contains all the {@link Chrono}s related to view status.
     * Chronos measure time lapses between events.
     * ie: between start and join, between seek-begin and seek-end, etc.
     * Each plugin will have an instance of this class.
     *
     * @constructs PlaybackChronos
     * @extends YouboraObject
     * @memberof youbora
     */
    constructor: function () {
      this.reset()
    },

    /** Reset flag values */
    reset: function () {
      /** Chrono between start and joinTime. */
      this.join = new Chrono()

      /** Chrono between seek-begin and seek-end. */
      this.seek = new Chrono()

      /** Chrono between pause and resume. */
      this.pause = new Chrono()

      /** Chrono between buffer-begin and buffer-end. */
      this.buffer = new Chrono()

      /** Chrono for the totality of the view. */
      this.total = new Chrono()
    }
  }
)

module.exports = PlaybackChronos


/***/ }),
/* 24 */
/***/ (function(module, exports, __webpack_require__) {

var YouboraObject = __webpack_require__(1)

var PlaybackFlags = YouboraObject.extend(
  /** @lends PlaybackFlags.prototype */
  {
    /**
     * This class contains all the flags related to view status.
     * Each plugin will have an instance of this class.
     *
     * @constructs PlaybackFlags
     * @extends YouboraObject
     * @memberof youbora
     */
    constructor: function () {
      this.reset()
    },

    /** Reset flag values */
    reset: function () {
      /** Flag when Start has been sent. */
      this.isStarted = false

      /** Flag when Join has been sent. */
      this.isJoined = false

      /** Flag when Player is paused. */
      this.isPaused = false

      /** Flag when Player is seeking. */
      this.isSeeking = false

      /** Flag when Player is buffering. */
      this.isBuffering = false
    }
  }
)

module.exports = PlaybackFlags


/***/ }),
/* 25 */
/***/ (function(module, exports, __webpack_require__) {

var Transform = __webpack_require__(4)
var Constants = __webpack_require__(5)

/**
 * This class manages Flow restrictions. All requests shall be blocked until /init or /start are
 * received.
 *
 * @constructs
 * @extends Transform
 * @memberof youbora
 *
 * @param {Plugin} plugin Instance of {@link Plugin}
 */
var FlowTransform = Transform.extend(
  /** @lends FlowTransform.prototype */
  {
    _services: [Constants.Service.INIT, Constants.Service.START],

    /**
     * Returns if transform is blocking.
     *
     * @param {YBRequest} request Request to transform.
     * @return {bool} True if queue shall be blocked.
     */
    isBlocking: function (request) {
      if (this._isBusy && request != null && this._services.indexOf(request.service) !== -1) {
        this.done()
      }

      return Transform.prototype.isBlocking.apply(this, arguments)
    }
  }
)

module.exports = FlowTransform


/***/ }),
/* 26 */
/***/ (function(module, exports, __webpack_require__) {

// No-Conflict
var previousYoubora = youbora
var youbora = {}

/**
 * This allows you to run multiple instances of YouboraLib on the same webapp.
 * After loading the new version, call `noConflict()` to get a reference to it.
 * At the same time the old version will be returned to Youbora.
 */
youbora.noConflict = function () {
  youbora = previousYoubora
  return this
}

// Info
youbora.VERSION = __webpack_require__(9)

// Polyfills
youbora.polyfills = __webpack_require__(21)

// Classes
youbora.Object = __webpack_require__(1)
youbora.Emitter = __webpack_require__(2)
youbora.Util = __webpack_require__(7)
youbora.Chrono = __webpack_require__(6)
youbora.Timer = __webpack_require__(8)
youbora.Constants = __webpack_require__(5)

// Log
youbora.Log = __webpack_require__(0)
youbora.Log.loadLevelFromUrl()

// Comm classes
youbora.Request = __webpack_require__(3)
youbora.Communication = __webpack_require__(12)

// Resource Transform
youbora.Transform = __webpack_require__(4)
youbora.ViewTransform = __webpack_require__(17)
youbora.Nqs6Transform = __webpack_require__(13)
youbora.ResourceTransform = __webpack_require__(14)
youbora.CdnParser = __webpack_require__(15)
youbora.HlsParser = __webpack_require__(16)

// Plugin Classes
youbora.Options = __webpack_require__(18)
youbora.Plugin = __webpack_require__(20)
youbora.RequestBuilder = __webpack_require__(19)

// Adapters
youbora.PlayheadMonitor = __webpack_require__(11)
youbora.Adapter = __webpack_require__(10)
youbora.adapters = {}

module.exports = youbora


/***/ })
/******/ ]);
});


// WEBPACK FOOTER //
// youboralib.min.js